const iframe = document.createElement("iframe");
iframe.style.display = "none";
document.body.appendChild(iframe);
const console = iframe.contentWindow.console;

// ***GLOBAL (SHOPIFY SPECIFIC)***
const global = {
	sanitizePrice: function (s) {
		function dotAndCommaSwitcher(match) {
			return match == "," ? "." : ",";
		}

		// currency formatting: https://help.shopify.com/en/manual/markets/pricing/currency-formatting
		if (siteMoneyFormat.includes("amount_with_comma_separator")) {
			return s.replaceAll(/\.|\,/g, dotAndCommaSwitcher);
		} else {
			return s;
		}
	},
	formatSplitPrice: function (price) {
		if (!price) return false;

		// account for commas and decimals
		// "$10,100.99 USD" => ['$', 10100.99, 'USD']
		const priceSanitized = this.sanitizePrice(price);
		const regex = /([^0-9]*)([0-9,]+[\\\\.\\\\,]?[0-9]*)([^0-9]*)/;
		const match = priceSanitized.match(regex);

		return {
			symbol: match[1],
			value: parseFloat(match[2].replace(/[\\\\,]/g, "")),
			currency: match[3],
		};
	},
	formatShopifyMoney: function (price) {
		const priceFixed = Number(price).toFixed(2);
		const value = siteMoneyFormat.includes("amount_with_comma_separator")
			? formatNumberEuro(priceFixed).replace(",00", "")
			: formatNumberCommas(priceFixed).replace(".00", "");

		return siteMoneyFormat.replace(/\{\{(.*?)\}\}/gs, value);
	},
};

// ***WYSIWYG (SHOPIFY SPECIFIC)***
const cWysiwygShopify = {
	init: function () {
		// shopify - add wysiwyg styling to policy text
		const shopifyPolicyBody = document.querySelector(".shopify-policy__body");
		if (shopifyPolicyBody) {
			shopifyPolicyBody.firstElementChild.classList.add(
				"wysiwyg",
				"wysiwyg-page"
			);
		}

		// shopify - remove meta information
		document
			.querySelectorAll(".wysiwyg meta[charset], .wysiwyg-page meta[charset]")
			.forEach((el) => el.remove());
	},
};

// ***ITEM VARIANTS***
const cItemVariants = {
	updateVariantPillCurrentSelection: function (variantSelector, value, label) {
		const variantGroup = variantSelector.closest(".js-variant-group");
		const selected = variantGroup.querySelector(".js-variant-pills-selected");

		if (selected) {
			selected.dataset.label = value;
			selected.dataset.labelCurrent = label;
		}
	},
	init: function () {
		on("body", "mouseover", ".js-variant-group .js-variant-selector", (e) => {
			const target = e.target.closest(".js-variant-selector");
			this.updateVariantPillCurrentSelection(
				target,
				target.value,
				target.dataset.label
			);
		});

		on("body", "mouseout", ".js-variant-group .js-variant-selector", (e) => {
			const target = e.target.closest(".js-variant-selector");
			const isInput = target.tagName == "INPUT";
			const selection = document.querySelector(
				`[name="${target.name}"]${isInput ? ":checked" : ""}`
			);

			this.updateVariantPillCurrentSelection(
				target,
				"",
				selection ? selection.dataset.label : ""
			);
		});
	},
};

// ***ITEM SELLING PLAN***
const cItemSellingPlan = {
	init: function () {
		on(
			"body",
			"change",
			'.c-item-selling-plan input[type="radio"][name*="selling-plan-"]',
			(e) => {
				const target = e.target.closest(
					'input[type="radio"][name*="selling-plan-"]'
				);
				const sellingPlanComponent = target.closest(".c-item-selling-plan");
				const selector = sellingPlanComponent.querySelector(
					'[name="selling_plan"]'
				);

				// if subscription is not selected, set selling_plan selector to disabled
				selector.disabled = target.value == "subscription" ? false : true;
			}
		);
	},
};

// ***ITEM QUANTITY***
const cItemQuantity = {
	updateQuantity: function (itemQuantity, increase) {
		const input = itemQuantity.querySelector('input[name="quantity"]');
		const inputDecrease = itemQuantity.querySelector(
			'[data-trigger="decrease"]'
		);
		const inputIncrease = itemQuantity.querySelector(
			'[data-trigger="increase"]'
		);

		// update input
		const value = parseInt(input.value);
		const valueChange =
			increase === true
				? value + 1 <= parseInt(input.max)
					? 1
					: 0
				: value - 1 >= parseInt(input.min)
					? -1
					: 0;
		const newValue = value + (increase !== undefined ? valueChange : 0);
		const newValueFormatted =
			input.dataset.leadingZero == "true" ? formatPad(newValue) : newValue;

		// button disabled state
		inputDecrease.disabled = newValue <= input.min ? true : false;
		inputIncrease.disabled = newValue >= input.max ? true : false;

		// input value has changed!
		if (newValueFormatted != input.value) {
			input.value = newValueFormatted;
			// Update the value attribute in the HTML source
			input.setAttribute("value", newValueFormatted);

			const eventChange = new Event("change");
			input.dispatchEvent(eventChange);
		}
	},
	init: function () {
		on("body", "click", ".c-item-quantity [data-trigger]", (e) => {
			const target = e.target.closest("[data-trigger]");
			const itemQuantity = target.closest(".c-item-quantity");

			this.updateQuantity(itemQuantity, target.dataset.trigger == "increase");
		});
	},
};

// ***PRODUCT FORM***
const cProductForm = {
	saveVariantSelection: function (form, selection, variantsJson) {
		const variantSelectors = form.querySelectorAll(".js-variant-selector");

		// save variantTitle
		variantSelectors.forEach((el) => {
			const isInput = el.tagName == "INPUT";
			const title = isInput ? (el.checked ? el.value : false) : el.value;
			if (title) {
				selection["variantTitle"].push(title);
			}
		});

		// save variantObject
		selection["variantIndex"] = variantsJson.findIndex((object) => {
			return object.title === selection["variantTitle"].join(" / ");
		});
		selection["variantObject"] = variantsJson[selection["variantIndex"]];
	},
	updatePrice: function (form, variantObject) {
		const priceComponents = form.querySelectorAll(".c-item-price");

		priceComponents.forEach((priceComponent) => {
			const priceAdj = parseFloat(priceComponent.dataset.regularPriceAdj) || 1;
			const globalDiscount = priceComponent.dataset.globalDiscountAdj;
			const globalDiscountAdj = parseFloat(globalDiscount) || 1;

			const priceRegular = priceComponent.querySelector(".js-price-regular");
			const variantPrice = variantObject.price;

			if (priceRegular) {
				const { value, symbol } = global.formatSplitPrice(variantPrice);
				const formattedPrice = global.formatShopifyMoney(
					value * priceAdj * globalDiscountAdj
				);

				priceRegular.innerHTML =
					`<span class="currency">${symbol}</span>` +
					formattedPrice.replace(symbol, "");
			}

			const priceCompare = priceComponent.querySelector(".js-price-compare");
			if (priceCompare) {
				const variantComparePrice = variantObject.priceCompare;
				const { value, symbol, currency } =
					variantComparePrice != "" && variantComparePrice != variantPrice
						? global.formatSplitPrice(variantComparePrice)
						: // use original price as compare-at-price for global discount
							globalDiscount
							? global.formatSplitPrice(variantPrice)
							: {};

				const formattedPrice = value ? global.formatShopifyMoney(value) : "";

				priceCompare.innerHTML = value
					? `<span class="currency">${symbol}</span>` +
						formattedPrice.replace(symbol, "").replace(currency, "")
					: "";
			}

			const priceMember = priceComponent.querySelector(".js-price-member");
			// Additive stacking: the sale % and the 10% member discount both
			// come off the original price (multiplier = globalDiscountAdj - 0.1),
			// matching c-item-price.liquid and the checkout discount function.
			const priceMemberAdj = globalDiscount
				? Math.max(globalDiscountAdj - 0.1, 0)
				: 0.9;
			if (priceMember) {
				const { value, symbol } = global.formatSplitPrice(variantPrice);
				const formattedPrice = global.formatShopifyMoney(
					value * priceAdj * priceMemberAdj
				);
				priceMember.innerHTML =
					`<span class="currency">${symbol}</span>` +
					formattedPrice.replace(symbol, "");
			}
		});
	},
	updateQuantity: function (form, variantObject) {
		const maxInventory = variantObject.inventory;
		const inputQuantity = form.querySelector('input[name="quantity"]');

		if (!inputQuantity) return;

		// set max inventory
		inputQuantity.max = maxInventory;

		// prevent quantity from going over variant max inventory
		if (parseInt(inputQuantity.value) > maxInventory && maxInventory != 0) {
			inputQuantity.value = maxInventory;
		}

		// dispatch update event to quantity component
		const quantityComponent = form.querySelector(".c-item-quantity");
		cItemQuantity.updateQuantity(quantityComponent);
	},
	updateFormId: function (form, variantObject) {
		const inputId = form.querySelector('input[name="id"]');

		inputId.value = variantObject.id;
	},
	updateFormSubmitState: function (form, variantObject, target) {
		const cartHasMembership = root.classList.contains("cart-has-membership");
		const isLoggedInMember = root.classList.contains("is-login-member");
		const hasMembersOnly = root.classList.contains("has-members-only");
		const productForms = document.querySelectorAll(".c-product-form");
		// Check if it is a color swatch to trigger the member-only state
		const isMembersOnly =
			variantObject.productMembersOnly === "true"
				? variantObject.productMembersOnly
				: variantObject.variantMembersOnly === "true";
		const formAddId = form.querySelector("input[name='id']");
		const isColorSwatch = target.closest("[data-swatch-color]");
		const formSubmit = form.querySelector(".js-form-submit");
		const formMembersOnly = document.querySelector("[data-members-only-form]");
		const formBackInStock = document.querySelector(
			'form[action="back_in_stock"]'
		);
		const availabilityDisabled = form.dataset.availabilityDisabled === "true";

		formBackInStock?.classList.toggle(
			"is-hidden",
			isMembersOnly &&
				!cartHasMembership &&
				!isLoggedInMember &&
				!availabilityDisabled
		);

		root.classList.toggle("is-members-only", isMembersOnly);
		formAddId.classList.toggle("is-members-only", isMembersOnly);

		if (!formMembersOnly) return false;

		const formAvailability = () => {
			// Check if the variant is in stock
			const isAvailable =
				variantObject.inventory > 0 &&
				form.dataset.availabilityDisabled !== "true";
			form.dataset.available = isAvailable;

			if (!formSubmit) return;
			// Disable the submit button if:
			// - The product is out of stock
			// - It's a limited-purchase product that has already been purchased
			formSubmit.disabled =
				!isAvailable ||
				(form.classList.contains("is-limited-purchase") &&
					form.classList.contains("is-purchased"));
		};

		//clicking on color swatch & cart has no membership
		if (isColorSwatch && hasMembersOnly) {
			updateProductForm(productForms, variantObject.url);
		}

		formAvailability();
	},
	updateUrl: function (variantObject) {
		// Keep the entry's state: productSwap marks its history entries and only
		// handles popstate for the ones it marked.
		window.history.replaceState(
			window.history.state,
			"",
			`?variant=${variantObject.id}`
		);
	},
	updateVariantDisabledState: function (formElement, variants) {
		const variantGroups = formElement.querySelectorAll(".js-variant-group");
		const inStockVariants = variants.filter((variant) => variant.inventory > 0);

		// disable if there's only one variant group
		// if (variantGroups.length <= 1) return false;

		// Get an array of selected variant values for each variant group
		const selectedVariants = Array.from(variantGroups).map((variantGroup) => {
			const isInput = variantGroup.querySelector("input.js-variant-selector");
			const selection = variantGroup.querySelector(
				`.js-variant-selector${isInput ? ":checked" : ""}`
			);

			return selection && selection.value != "" ? selection.value : false;
		});

		if (selectedVariants.includes(false)) return false;

		// Loop through each variant group
		// & disable the selected/unselected variant if the combination is not in stock
		Array.from(variantGroups).forEach((variantGroup, index) => {
			const isInput = variantGroup.querySelector("input.js-variant-selector");
			// Find all unselected variants in the group
			const unselectedVariants = variantGroup.querySelectorAll(
				`.js-variant-selector${!isInput ? " option" : ""}`
			);

			unselectedVariants.forEach((unselectedVariant) => {
				// Create a new array of variant values with the current unselected variant included
				const selectedVariantValues = [...selectedVariants];
				selectedVariantValues[index] = unselectedVariant.value;

				// Check if the combination of variant values is in stock
				const combinationInStock = inStockVariants.some((variant) => {
					const selectedVariantTitles = selectedVariantValues.join(" / ");
					// Check if the variant title matches the selected variant values
					return variant.title === selectedVariantTitles;
				});

				// Add is-disabled class to the unselected variant if the combination is not in stock
				unselectedVariant.classList.toggle("is-disabled", !combinationInStock);

				// Update the text of the unselected variant to indicate if it is sold out
				if (unselectedVariant.tagName === "OPTION") {
					unselectedVariant.innerText = `${unselectedVariant.value}${
						combinationInStock ? "" : " - sold out"
					}`;
				}
			});
		});
	},
	updateProductState: function (target) {
		// A combined-listing colour is a sibling product: swap the page to it in
		// place. The quick-add panel handles its own swatches before this runs.
		if (target.dataset.swatchUrl && !target.closest(".c-cart")) {
			productSwap.go(target.dataset.swatchUrl);
			return;
		}

		const form = target.closest(".c-product-form");
		const variantsJson = validateJson(
			form.dataset.variantsJson.replace(/'/g, '"').trim()
		);
		const selection = {
			selectorIndex: null,
			variantTitle: [],
			variantIndex: null,
			variantObject: null,
		};

		// save selection in object
		if (form && variantsJson) {
			this.saveVariantSelection(form, selection, variantsJson);
		}

		// trigger updates based on selected variant
		const selectedVariant = selection["variantObject"];

		if (form && selectedVariant) {
			this.updatePrice(form, selectedVariant);
			this.updateQuantity(form, selectedVariant);
			this.updateFormId(form, selectedVariant);
			this.updateFormSubmitState(form, selectedVariant, target);

			if (form.dataset.updateVariantUrl == "true") {
				this.updateUrl(selectedVariant);
			}

			if (form.dataset.updateVariantDisabledState == "true") {
				this.updateVariantDisabledState(form, variantsJson);
			}

			// display product back-in-stock
			const productBis = document.querySelectorAll(".js-product-bis");
			if (productBis) {
				productBis.forEach((bis) => {
					if (selectedVariant.inventory <= 0) {
						bis.querySelector('input[name="bis-variant-id"]').value =
							selectedVariant.id;

						bis.classList.add("is-active");
						bis.classList.remove("is-success");
					} else {
						bis.classList.remove("is-success", "is-active");
					}
				});
			}
		}
	},
	updateDropdown: function (target, isColorSwatch) {
		const targetValue = target.value;
		const dropDownOption = target.closest(".js-selector-option");
		const parent = target.closest(".js-selector-parent");
		const nativeSelect = parent.querySelector("select");
		const dropDown = target.closest(".js-selector");
		const dropDownDisplay = dropDown.querySelector(".js-selector-display");
		const dropDownOptions = dropDown.querySelectorAll(".js-selector-option");

		if (isColorSwatch) {
			const swatch = parent.querySelector(".js-selector-swatch");
			const label = parent.querySelector(".js-selector-label");

			swatch.dataset.swatchColor = formatHandleize(targetValue);
			label.textContent = targetValue;
		} else {
			dropDownDisplay.textContent = targetValue;
		}

		dropDownOptions.forEach((option) => {
			const variantSelector = option.querySelector(".js-variant-selector");
			option.classList.remove("is-active");
			if (variantSelector) {
				variantSelector.checked = false;
				variantSelector.removeAttribute("checked");
			}
		});

		const activeVariantSelector = dropDownOption.querySelector(
			".js-variant-selector"
		);
		dropDownOption.classList.add("is-active");
		if (activeVariantSelector) {
			activeVariantSelector.checked = true;
			activeVariantSelector.setAttribute("checked", "checked");
		}

		//sync with native select
		nativeSelect.value = targetValue;
		dropDown.classList.remove("is-active");
	},
	updateVariantsFromDropdownContext: function (form, dropdownContainer) {
		const formVariants = form.querySelectorAll(".js-variant-selector");

		// Uncheck all variants
		formVariants.forEach((variant) => {
			variant.checked = false;
			variant.removeAttribute("checked");
		});

		// Check matching variants from dropdown
		dropdownContainer
			.querySelectorAll(".js-variant-selector:checked")
			.forEach((variant) => {
				const matching = form.querySelector(
					`.js-variant-selector[value="${variant.value}"]`
				);

				if (matching) {
					matching.checked = true;
					matching.setAttribute("checked", "checked");
				}
			});

		// Update data-label-current
		const labelCurrent = form.querySelector("[data-label-current]");
		const currentColor = form.querySelector(
			".js-variant-selector.is-color-selector:checked"
		);
		if (labelCurrent && currentColor) {
			labelCurrent.dataset.labelCurrent = currentColor.value;
		}
	},

	// Helper: Update a variant's UI
	updateVariantUI: function (variantSelector, form, dropdownContainer) {
		if (!variantSelector) return;

		const isColorSwatch =
			variantSelector.classList.contains("is-color-selector");
		const hasDropdownParent = variantSelector.closest(".js-selector-parent");

		if (hasDropdownParent) {
			this.updateDropdown(variantSelector, isColorSwatch);
		} else if (dropdownContainer) {
			this.updateVariantsFromDropdownContext(form, dropdownContainer);
		}

		this.updateProductState(variantSelector);
	},

	// Helper: Process a single form
	processForm: function (form, targetValue, dropdownContainer) {
		const variantSelector = form.querySelector(
			`.js-variant-selector[value="${targetValue}"]`
		);
		this.updateVariantUI(variantSelector, form, dropdownContainer);
	},

	init: function () {
		document.querySelectorAll(".c-product-form").forEach((form) => {
			if (!form.dataset.variantsJson) return false;

			const variantsJson = validateJson(
				form.dataset.variantsJson.replace(/'/g, '"').trim()
			);

			if (form.dataset.updateVariantDisabledState == "true") {
				this.updateVariantDisabledState(form, variantsJson);
			}

			// get preselected variants. if no variant is selected, only show the generic media
			const selection = {
				selectorIndex: null,
				variantTitle: [],
				variantIndex: null,
				variantObject: null,
			};
			this.saveVariantSelection(form, selection, variantsJson);
		});

		// MAIN handler
		on("body", "change", ".c-product-form .js-variant-selector", (e) => {
			const target = e.target.closest(".js-variant-selector");
			if (!target) return;
			if (target.closest(".c-line-item")) return;

			const targetValue = target.value;
			const form = target.closest(".c-product-form");
			const formId = form.dataset.formId;
			const dropdownContainer = target.closest(".js-variants-dropdown");

			const forms = document.querySelectorAll(
				`.c-product-form[data-form-id="${formId}"]`
			);
			forms.forEach((singleForm) => {
				this.processForm(singleForm, targetValue, dropdownContainer);
			});
		});

		//init dropdown
		on("body", "click", ".js-selector-trigger", (e) => {
			const dropdown = e.target.closest(".js-selector");
			if (!dropdown) return;
			dropdown.classList.toggle("is-active");
		});

		document.addEventListener("click", (e) => {
			const clickedDropdown = e.target.closest(".js-selector");
			document
				.querySelectorAll(".js-selector.is-active")
				.forEach((dropdown) => {
					if (dropdown !== clickedDropdown) {
						dropdown.classList.remove("is-active");
					}
				});
		});
	},
};

// ***PRODUCT SWAP***
// Combined-listing colours are separate products. Picking one on the PDP
// re-renders this page's main section for the sibling product through the
// Section Rendering API and swaps it in place instead of navigating. History,
// <title> / canonical and the widgets bound to the old markup follow along.
// No product-view analytics fire: Shopify's product_viewed only fires on a real
// page load, and that under-count was accepted. Listeners can hook in through
// the bubbling `bandit:product-swapped` event dispatched on the section.
const productSwap = {
	fetcher: null,
	currentPath: null,
	pendingPath: null,
	requestToken: 0,

	getSection: function () {
		return document
			.querySelector(".js-product-swap-root")
			?.closest(".shopify-section");
	},

	getCheckedSize: function (section) {
		return (
			section.querySelector(
				'.c-product-form .js-variant-group[class*="size"] .js-variant-selector:checked'
			)?.value || null
		);
	},

	go: function (swatchUrl) {
		const url = new URL(swatchUrl, window.location.origin);
		// The hero and sticky forms both route the same click here.
		if (url.pathname === this.pendingPath) return;
		if (url.pathname === this.currentPath && !this.pendingPath) return;

		this.swap(url, true);
	},

	cancel: function () {
		this.requestToken++;
		this.pendingPath = null;
		root.classList.remove("is-swapping-product");
	},

	swap: async function (url, isPush) {
		const section = this.getSection();
		if (!section || !this.fetcher) {
			window.location.assign(url.href);
			return;
		}

		// A swatch click carries the previous colour's size over; Back / Forward
		// restore exactly the variant in the URL.
		const sizeValue = isPush ? this.getCheckedSize(section) : null;
		const requestToken = ++this.requestToken;
		this.pendingPath = url.pathname;
		root.classList.add("is-swapping-product");

		try {
			const html = await this.fetcher.get(url.pathname + url.search);
			if (requestToken !== this.requestToken) return;

			const fetchedDocument = parseHtmlString(html);

			// A sibling on another product template has no section with this id.
			const incomingSection = fetchedDocument.getElementById(section.id);
			if (
				!incomingSection?.querySelector(".js-product-swap-root .c-product-form")
			) {
				throw new Error(`No ${section.id} in ${url.pathname}`);
			}

			// Start the new hero's images loading and hold the swap until its
			// opening image has decoded (capped), so the crossfade lands on a
			// picture rather than an empty frame; the current gallery stays on
			// screen meanwhile. A parsed document never fetches its images, so
			// adopting the section into this one is what starts them.
			document.adoptNode(incomingSection);
			await this.decodeImages(this.prepareHeroImages(incomingSection));
			if (requestToken !== this.requestToken) return;

			const restoredVariant = sizeValue
				? this.preselectSize(incomingSection, sizeValue)
				: null;
			const pushUrl = restoredVariant
				? `${url.pathname}?variant=${restoredVariant.id}`
				: url.pathname + url.search;

			if (isPush) {
				if (!window.history.state?.banditProductSwap) {
					window.history.replaceState(
						{ banditProductSwap: true },
						"",
						window.location.href
					);
				}
				window.history.pushState({ banditProductSwap: true }, "", pushUrl);
			}

			const hadFocus = section.contains(document.activeElement);

			// The Size Charts app (Clean Size Charts) fills .size-chart once on load
			// and has no re-init hook, but its trigger's click is delegated on
			// document, so carrying the injected markup over keeps it working.
			// Siblings share a silhouette, and with it a chart.
			const sizeChartHtml = Array.from(
				section.querySelectorAll(".size-chart"),
				(sizeChart) => sizeChart.innerHTML
			);

			const applySwap = () => {
				// <c-slider> has no disconnectedCallback, so its Embla instances would
				// outlive the markup they drive.
				section.querySelectorAll("c-slider").forEach((slider) => {
					slider.embla?.destroy();
					slider.emblaThumb?.destroy();
				});

				// Hold the old height for a frame so the page below doesn't jump while
				// the new markup lays out.
				section.style.minHeight = `${section.offsetHeight}px`;
				section.replaceChildren(...incomingSection.childNodes);
				this.currentPath = url.pathname;
				requestAnimationFrame(() => section.style.removeProperty("min-height"));

				section.querySelectorAll(".size-chart").forEach((sizeChart, index) => {
					if (!sizeChart.innerHTML.trim() && sizeChartHtml[index]) {
						sizeChart.innerHTML = sizeChartHtml[index];
					}
				});

				this.refreshPage(section);
				this.initForms(section);
				this.rerunScripts(section);

				section.dispatchEvent(
					new CustomEvent("bandit:product-swapped", {
						bubbles: true,
						detail: {
							productUrl: url.pathname,
							productId: section.querySelector(".js-product-swap-root")?.dataset
								.productSwapId,
						},
					})
				);

				this.refreshVendorWidgets();

				// The size is already checked in the new markup; the change event
				// brings price, id, the sticky form and stock state in line with it.
				if (restoredVariant) {
					Array.from(
						section.querySelectorAll(
							'.js-product-swap-root .c-product-form .js-variant-group[class*="size"] .js-variant-selector'
						)
					)
						.find((input) => input.checked && input.value === sizeValue)
						?.dispatchEvent(new Event("change", { bubbles: true }));
				}

				// Undimmed before the new state is captured for the crossfade.
				root.classList.remove("is-swapping-product");
			};

			// A short crossfade between the old and new section (0.2s, set in
			// styles/_p-product-2025.scss). Without View Transitions the swap is
			// instant.
			if (document.startViewTransition) {
				root.classList.add("is-product-swap-transition");
				const transition = document.startViewTransition(applySwap);
				const endTransition = () =>
					root.classList.remove("is-product-swap-transition");
				transition.finished.then(endTransition, endTransition);
				await transition.updateCallbackDone;
			} else {
				applySwap();
			}

			if (hadFocus) {
				section
					.querySelector(
						".c-product-form .js-variant-selector.is-color-selector:checked"
					)
					?.focus({ preventScroll: true });
			}
		} catch (error) {
			if (requestToken !== this.requestToken) return;
			console.error("Product swap failed, loading the page instead:", error);
			window.location.assign(url.href);
		} finally {
			if (requestToken === this.requestToken) {
				this.pendingPath = null;
				root.classList.remove("is-swapping-product");
			}
		}
	},

	// What is on screen the moment a hero swaps in: the active colour's first
	// two gallery slides (the 2026 hero shows two side by side on desktop) and
	// the hero's images outside the gallery, such as the feature icons. Lazy
	// ones are promoted so they load now; left to lazysizes they would go in
	// blank and fade in after the crossfade. Returns those images.
	prepareHeroImages: function (scope) {
		// lazysizes sizes a data-sizes="auto" image from its rendered width, which
		// a detached image doesn't have; borrow it from the copy on screen.
		const liveSizes = new Map();
		this.getSection()
			?.querySelectorAll("img[data-src][sizes]")
			.forEach((image) => {
				liveSizes.set(image.dataset.src, image.getAttribute("sizes"));
			});

		const images = [];
		scope
			.querySelectorAll(".product-hero, .js-pdp-hero-2026")
			.forEach((hero) => {
				hero
					.querySelectorAll(
						".product-hero__gallery c-slider.is-active, .js-pdp-hero-2026-gallery c-slider.is-active"
					)
					.forEach((slider) => {
						Array.from(slider.querySelectorAll(".embla__slide"))
							.slice(0, 2)
							.forEach((slide) => {
								const image = slide.querySelector("img");
								if (image) images.push(image);
							});
					});
				hero.querySelectorAll("img").forEach((image) => {
					if (!image.closest("c-slider")) images.push(image);
				});
			});

		images.forEach((image) => {
			if (!image.classList.contains("lazyload")) return;
			const sizes =
				image.dataset.sizes === "auto"
					? liveSizes.get(image.dataset.src) || "100px"
					: image.dataset.sizes;
			promoteLazyImage(image, sizes);
		});

		return images.filter((image) => image.getAttribute("src"));
	},

	// Resolves once every image has decoded, or after 1.5s at most, so a slow
	// network delays the swap rather than blanking the hero.
	decodeImages: function (images) {
		if (!images.length) return Promise.resolve();

		const decodeCap = new Promise((resolve) => setTimeout(resolve, 1500));
		return Promise.race([
			Promise.all(images.map((image) => image.decode().catch(() => {}))),
			decodeCap,
		]);
	},

	// Hovering, focusing or pressing a sibling colour is a strong hint: fetch its
	// section and start downloading the images its hero opens with, so the click
	// finds both ready. Only those images are warmed, not the whole section's.
	prefetch: function (swatchUrl) {
		const url = new URL(swatchUrl, window.location.origin);
		const cacheKey = url.pathname + url.search;
		if (url.pathname === this.currentPath || cacheKey === this.prefetchedKey) {
			return;
		}
		this.prefetchedKey = cacheKey;

		this.fetcher
			.get(cacheKey)
			.then((html) => {
				const fetchedDocument = parseHtmlString(html);
				this.prepareHeroImages(fetchedDocument).forEach((source) => {
					const image = new Image();
					if (source.getAttribute("sizes")) image.sizes = source.sizes;
					if (source.getAttribute("srcset")) image.srcset = source.srcset;
					image.src = source.getAttribute("src");
				});
			})
			.catch(() => {
				this.prefetchedKey = null;
			});
	},

	// What lives outside the section: <head> tags and the product-driven <html>
	// classes from snippets/html-page-variables.liquid.
	refreshPage: function (section) {
		const swapRoot = section.querySelector(".js-product-swap-root");
		if (!swapRoot) return;

		const {
			productSwapTitle,
			productSwapCanonical,
			productSwapDarkMode,
			productSwapWhiteHeader,
		} = swapRoot.dataset;

		if (productSwapTitle) {
			document.title = productSwapTitle;
			document
				.querySelector('meta[property="og:title"]')
				?.setAttribute("content", productSwapTitle);
		}

		const canonicalUrl = new URL(
			productSwapCanonical || window.location.pathname,
			window.location.origin
		);
		canonicalUrl.search = "";
		document
			.querySelector('link[rel="canonical"]')
			?.setAttribute("href", canonicalUrl.href);
		document
			.querySelector('meta[property="og:url"]')
			?.setAttribute("content", canonicalUrl.href);

		root.classList.toggle("is-dark-mode", productSwapDarkMode === "true");
		root.classList.toggle(
			"header-is-white-text",
			productSwapWhiteHeader === "true"
		);
	},

	// Third-party widgets in the section scan the page once, on load. Stamped
	// documents reloadUGC() for AJAX-inserted widgets; tfcapi("calculate") is
	// TrueFit's re-scan call (its stub in snippets/html-js-before-head.liquid
	// queues it if the script hasn't loaded yet). The Size Charts app is handled
	// in swap(), since it has no re-init hook.
	refreshVendorWidgets: function () {
		window.StampedFn?.reloadUGC?.();
		if (typeof window.tfcapi === "function") window.tfcapi("calculate");
	},

	// cProductForm.init() only scans forms present at page load.
	initForms: function (section) {
		section.querySelectorAll(".c-product-form").forEach((form) => {
			if (form.dataset.updateVariantDisabledState != "true") return;
			const variantsJson = validateJson(
				form.dataset.variantsJson?.replace(/'/g, '"').trim()
			);
			if (variantsJson) {
				cProductForm.updateVariantDisabledState(form, variantsJson);
			}
		});
	},

	// Scripts moved in from a parsed document never execute. The ones marked
	// data-swap-rerun (members-only <html> classes, recently-viewed tracking) are
	// written to be run again; everything else is not.
	rerunScripts: function (section) {
		root.classList.remove("is-members-only", "has-members-only");

		section.querySelectorAll("script[data-swap-rerun]").forEach((script) => {
			const freshScript = document.createElement("script");
			freshScript.textContent = script.textContent;
			script.replaceWith(freshScript);
		});
	},

	// The new colour renders with its first available size. When it stocks the
	// size the shopper had picked, check that size in the fetched markup before
	// it goes live, so the page never shows the default size first. Returns the
	// matching variant, or null to keep the default.
	preselectSize: function (incomingSection, sizeValue) {
		const form = incomingSection.querySelector(
			".js-product-swap-root .c-product-form"
		);
		const variantsJson = validateJson(
			form?.dataset.variantsJson?.replace(/'/g, '"').trim()
		);
		if (!variantsJson) return null;

		const colorValue = form.querySelector(
			".js-variant-selector.is-color-selector:checked"
		)?.value;
		const colorName = colorValue ? formatHandleize(colorValue) : null;

		const variant = variantsJson.find(
			(item) =>
				item.sizeName === sizeValue &&
				(!colorName || item.colorName === colorName) &&
				Number(item.inventory) > 0
		);
		if (!variant) return null;

		// Hero and sticky forms alike.
		incomingSection
			.querySelectorAll('.c-product-form .js-variant-group[class*="size"]')
			.forEach((sizeGroup) => {
				sizeGroup.querySelectorAll(".js-variant-selector").forEach((input) => {
					const isMatch = input.value === sizeValue;
					input.checked = isMatch;
					input.toggleAttribute("checked", isMatch);
				});
			});

		return variant;
	},

	init: function () {
		const section = this.getSection();
		if (!section) return;

		// The live section id (template--…__main), not the bare file name: that
		// would render without this template's settings and market overrides.
		const sectionId = section.id.replace(/^shopify-section-/, "");
		this.fetcher = createSectionFetcher(sectionId, 6);
		this.currentPath = window.location.pathname;
		this.prefetchedKey = null;

		on(
			"body",
			"pointerover",
			".js-product-swap-root .js-variant-selector[data-swatch-url]",
			(event, swatch) => this.prefetch(swatch.dataset.swatchUrl)
		);
		on(
			"body",
			"focusin",
			".js-product-swap-root .js-variant-selector[data-swatch-url]",
			(event, swatch) => this.prefetch(swatch.dataset.swatchUrl)
		);
		on(
			"body",
			"pointerdown",
			".js-product-swap-root .js-variant-selector[data-swatch-url]",
			(event, swatch) => this.prefetch(swatch.dataset.swatchUrl)
		);

		window.addEventListener("popstate", (event) => {
			if (!event.state?.banditProductSwap) return;

			const url = new URL(window.location.href);
			if (url.pathname === this.currentPath) {
				this.cancel();
				return;
			}
			this.swap(url, false);
		});
	},
};

// ***CART***
// Per-line-item cache of parsed variantsJson (avoids re-parsing on every change)
const lineItemVariantsCache = new WeakMap();

// Bypass the HTTP cache on every cart read. A cached /cart.js or minicart
// section render yields stale line keys, and /cart/update.js is atomic — one
// stale key rejects the whole batch, so the removal silently does nothing.
const CART_FETCH_OPTIONS = { cache: "no-store", credentials: "same-origin" };

// Toggles the global cart-updating state (page-wide overlay + progress bar).
// Pass a line item to also flag that specific row as updating.
const cartUpdating = {
	start: (item) => {
		if (item) item.classList.add("is-variant-updating");
		root.classList.add("is-cart-updating");
		loader.updateProgress(root);
	},
	end: (item) => {
		if (item) item.classList.remove("is-variant-updating");
		root.classList.remove("is-cart-updating");
		loader.complete(root);
	},
};

const cCart = {
	// Reads JSON from a cart endpoint, throwing with Shopify's own reason when the
	// request failed.
	//
	// Every cart read must go through this. A failed request still returns a JSON
	// body — `{status, message, description}` — which has no `items` and no
	// `total_price`. Parsing it as though it were a cart is what turned failures
	// into silent wrong-state bugs: callers either crash halfway through a flow,
	// leaving the UI in a transitional state nothing clears, or render `undefined`
	// as a real value. Throwing forces the caller to decide what to do.
	cartJson: async function (url) {
		const response = await fetch(url, CART_FETCH_OPTIONS);
		// An error page (HTML) makes .json() reject, so don't let that mask the
		// status we actually want to report.
		const data = await response.json().catch(() => null);
		if (!response.ok || !data) {
			throw new Error(
				`${url} → ${data?.description || data?.message || response.status}`
			);
		}
		return data;
	},

	// *** cart level updates ***
	applyCartStats: function (data) {
		const totals = this.computeCartTotals(data);

		// Cached PDP colour sections render cart state (limited-purchase lock).
		productSwap.fetcher?.clear();

		totals.itemCount > 0
			? root.classList.remove("is-cart-empty")
			: root.classList.add("is-cart-empty");

		root.classList.toggle("cart-has-items", totals.itemCount > 0);

		document
			.querySelectorAll(".c-cart")
			.forEach((el) => el.setAttribute("data-item-count", totals.itemCount));

		document
			.querySelectorAll(".js-cart-item-count, .cart-total-items")
			.forEach((el) => {
				el.innerText = totals.adjustedItemCount;
				el.setAttribute("data-cart-count", totals.adjustedItemCount);
				el.classList.add("is-active");
			});

		// free shipping
		const freeshipping = document.querySelector(".js-freeshipping-threshold");
		if (freeshipping) {
			// Pickup-only products (custom.pickup_only metafield) never ship, so they
			// don't count toward the threshold (mirrors snippets/c-cart.liquid).
			// /cart.js has no metafields, so the flag comes from the rendered rows.
			const pickupOnlyProductIds = new Set(
				[...document.querySelectorAll(".js-line-item[data-pickup-only]")].map(
					(lineItem) => Number(lineItem.dataset.productId)
				)
			);
			const pickupOnlyTotal = data.items
				.filter((cartItem) => pickupOnlyProductIds.has(cartItem.product_id))
				.reduce((sum, cartItem) => sum + cartItem.final_line_price, 0);
			const newPrice = parseFloat((data.total_price - pickupOnlyTotal) / 100);
			freeshipping.dataset.cartTotal = newPrice;
			this.updateFreeShipping(newPrice, freeshipping);
		}

		// membership pricing
		document
			.querySelectorAll(".js-cart-membership")
			.forEach((el) => this.updateMembershipPrices(data, el));

		// sync member discount display on individual line items
		this.updateCartLineItemMemberState();
	},

	// *** membership pricing ***
	updateMembershipPrices: function (data, membership) {
		const memberDiscountAmount =
			parseInt(membership.dataset.memberDiscount, 10) || 0;

		const totals = this.computeCartTotals(data, { memberDiscountAmount });

		const finalEl = membership.querySelector(".js-membership-final");
		const strikeEl = membership.querySelector(".js-membership-strikethrough");
		const savedEl = membership.querySelector(".js-membership-saved-amount");
		const savedLine = membership.querySelector(
			".js-membership-paragraph-saved"
		);

		const cartTotalMoney = global.formatShopifyMoney(data.total_price / 100);
		if (finalEl) finalEl.innerText = cartTotalMoney;

		// Strikethrough only when member with non-zero savings.
		if (strikeEl) {
			if (totals.isMember && totals.savedAmount > 0) {
				strikeEl.innerText = global.formatShopifyMoney(
					totals.regularPrice / 100
				);
			} else {
				strikeEl.innerText = "";
			}
		}

		const savedMoney = global.formatShopifyMoney(totals.savedAmount / 100);
		if (savedEl) savedEl.innerText = savedMoney;
		if (savedLine) {
			const savedParagraph = savedLine.closest(
				".js-membership-paragraph-saved"
			);
			const showSaved = totals.isMember && !totals.isMembershipOnlyCart;
			savedLine.classList.toggle("is-hidden", !showSaved);
			if (savedParagraph)
				savedParagraph.classList.toggle("is-hidden", !showSaved);
		}
	},

	// *** pure-math cart totals ***
	computeCartTotals: function (data, opts) {
		const {
			memberDiscountAmount = 0,
			memberProductId = 7466336354454,
			giftCardProductId = 7667360891030,
		} = opts || {};

		const memberDiscount = (100 - memberDiscountAmount) * 0.01;
		const cartHasMembership = root.classList.contains("cart-has-membership");
		const isMember = root.classList.contains("is-login-member");
		// Derived from fresh data — not the .cart-has-items class (which can lag).
		const cartHasProduct = data.item_count > 0;

		let membershipComplimentaryCount = 0;
		let membershipsProductTotal = 0;
		let membershipPrice = 0;
		let insurancePrice = 0;
		let cartItemGiftCardTotal = 0;
		let excludeMemberDiscountTotal = 0;
		let membershipGiftTotal = 0;
		let isMembershipOnlyCart = data.items.length > 0;

		data.items.forEach((item) => {
			const finalTotal = item.final_price * item.quantity;
			const type = item.properties?.Type;
			const _type = item.properties?._type;

			if (type === "Member Product" || _type === "membershipGiftAddOnProduct")
				membershipComplimentaryCount += item.quantity;

			if (
				isMembershipOnlyCart &&
				!(
					type === "Member Product" ||
					type === "Membership" ||
					_type === "membershipGiftAddOnProduct" ||
					_type === "membershipGift"
				)
			) {
				isMembershipOnlyCart = false;
			}

			if (item.product_id === memberProductId) {
				// Exclude gift memberships from the prefix total (only count the actual membership)
				if (_type !== "membershipGift") {
					membershipsProductTotal += item.line_price;
				}
				if (cartHasMembership && _type !== "membershipGift") {
					membershipPrice += finalTotal;
				}
			}
			if (item.product_type === "Insurance") {
				insurancePrice += finalTotal;
			}
			if (item.gift_card && item.product_id === giftCardProductId) {
				cartItemGiftCardTotal += finalTotal;
			}
			if (
				item.properties?._excludeMemberDiscount &&
				_type !== "membershipGift" &&
				_type !== "membershipGiftAddOnProduct"
			) {
				excludeMemberDiscountTotal += finalTotal;
			}
			if (
				_type === "membershipGift" ||
				_type === "membershipGiftAddOnProduct"
			) {
				membershipGiftTotal += finalTotal;
			}
		});

		const adjustedItemCount = data.item_count - membershipComplimentaryCount;

		const totalPrice =
			data.items_subtotal_price - membershipPrice - insurancePrice;
		const discountableTotal =
			totalPrice -
			cartItemGiftCardTotal -
			excludeMemberDiscountTotal -
			membershipGiftTotal;
		const nonDiscountableTotal =
			cartItemGiftCardTotal + excludeMemberDiscountTotal + membershipGiftTotal;

		// items_subtotal_price is pre-discount; member discount arrives as an allocation
		const appliedDiscount = data.total_discount || 0;

		const regularPrice = discountableTotal + nonDiscountableTotal;

		const memberPrice =
			isMember || cartHasMembership
				? appliedDiscount > 0
					? regularPrice - appliedDiscount
					: discountableTotal * memberDiscount + nonDiscountableTotal
				: discountableTotal * memberDiscount + nonDiscountableTotal;

		const savedAmount = Math.max(0, Math.round(regularPrice - memberPrice));

		return {
			itemCount: data.item_count,
			adjustedItemCount,
			regularPrice,
			memberPrice,
			membershipPrice,
			membershipsProductTotal,
			membershipGiftTotal,
			totalPrice,
			savedAmount,
			isMembershipOnlyCart,
			shouldBeMember: cartHasMembership || isMember,
			cartHasMembership,
			isMember,
			cartHasProduct,
		};
	},

	// *** variant-swap server mutation ***
	swapLineItemVariant: function ({
		oldVariantId,
		newVariantId,
		extraProperties = {},
		callback,
	}) {
		this.cartJson("/cart.js")
			.then((cart) => {
				const formData = { updates: {}, properties: {} };

				const currentItem = cart.items.find(
					(item) => item.id === parseInt(oldVariantId)
				);
				if (currentItem?.properties) {
					formData.properties = { ...currentItem.properties };
				}

				formData.updates[parseInt(oldVariantId)] = 0;
				formData.updates[parseInt(newVariantId)] = 1;

				// Overlay extraProperties; explicit undefined/null removes a key
				Object.entries(extraProperties).forEach(([key, val]) => {
					if (val) formData.properties[key] = val;
					else delete formData.properties[key];
				});

				return fetch("/cart/update.js", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(formData),
				})
					.then((response) =>
						response.json().then((data) => {
							// Atomic endpoint: on failure neither the removal nor the add
							// happened, so there's no new line to re-stamp properties on.
							if (!response.ok) {
								console.error(
									"Variant swap failed:",
									data?.description || data?.message || response.status
								);
								return null;
							}
							return data;
						})
					)
					.then((data) => {
						// Callers re-render the cart in their callback, which restores the
						// row to its pre-swap state.
						if (!data) {
							callback && callback();
							return;
						}

						// If properties changed, follow up with /cart/change.js so properties stick on the new line
						if (Object.keys(formData.properties).length > 0) {
							const changedItemId = data.items_changelog?.added[0]?.variant_id;
							if (changedItemId) {
								const matchedItem = data.items.find(
									(item) => item.id === changedItemId
								);
								if (matchedItem) {
									return fetch("/cart/change.js", {
										method: "POST",
										headers: {
											"Content-Type": "application/json",
										},
										body: JSON.stringify({
											id: matchedItem.key,
											properties: formData.properties,
										}),
									})
										.then((response) => {
											// The swap already happened; only the property
											// re-stamp can fail here. Left unreported, the new
											// line silently loses flags like Type: Member
											// Product, which the membership cascade and
											// members-only pricing both key off.
											if (!response.ok) {
												return response
													.json()
													.catch(() => null)
													.then((data) => {
														console.error(
															"Cart line properties not carried over after variant swap:",
															data?.description ||
																data?.message ||
																response.status
														);
													});
											}
										})
										.then(() => callback && callback(matchedItem))
										.catch((error) =>
											console.error("Error updating cart:", error)
										);
								}
							}
						}
						callback && callback();
					});
			})
			.catch((error) => {
				console.error("Variant swap failed:", error);
				// The caller flagged the row as updating (opacity 0.4, pointer-events
				// off) and raised the page overlay before calling us, and only the
				// callback clears them. Without this the row stays greyed out and
				// unclickable until the shopper reloads the page.
				callback && callback();
			});
	},

	// *** OOS safety net — re-click first available sibling if the selected option came back disabled ***
	rescueDisabledSelections: function () {
		// Treatment cart (.c-line-item uses form inputs)
		document
			.querySelectorAll(".c-line-item .js-variant-selector")
			.forEach((option) => {
				if (option.checked && option.disabled) {
					const firstAvailable = getSiblings(option).find((s) => !s.disabled);
					if (firstAvailable) firstAvailable.click();
				}
			});
	},

	async updateCartStats(cartData, revision = this.cartRevision) {
		try {
			if (revision !== this.cartRevision) return;
			const data = cartData || (await this.cartJson("/cart.js"));
			if (revision === this.cartRevision) this.applyCartStats(data);
		} catch (error) {
			// Leave the last known-good totals on screen rather than zeroing them.
			console.error("Cart stats not refreshed:", error);
		}
	},
	cartRevision: 0,
	cartMutationsInFlight: 0,
	pendingQuantityInputs: new Set(),
	bogosRefreshPending: false,
	bogosRefreshInFlight: false,

	initBogosCartRefresh: function () {
		document.addEventListener("fg-cart:auto-updated", (event) => {
			const {
				arrGiftsAdd: giftsAdded = [],
				arrGiftsRemove: giftsRemoved = [],
			} = event.detail || {};
			if (!giftsAdded.length && !giftsRemoved.length) return;
			this.bogosRefreshPending = true;
			this.refreshBogosCart();
		});
	},

	// BOGOS can finish before our original request paints. Wait for it and any edits.
	async refreshBogosCart() {
		if (
			!this.bogosRefreshPending ||
			this.bogosRefreshInFlight ||
			this.cartMutationsInFlight ||
			this.pendingQuantityInputs.size ||
			!document.querySelector(".c-cart")
		)
			return;
		this.bogosRefreshPending = false;
		this.bogosRefreshInFlight = true;
		const revision = ++this.cartRevision;
		try {
			await this.updateCartContent(undefined, { revision, background: true });
		} finally {
			// A newer edit invalidated this response; refresh once that edit finishes.
			if (revision !== this.cartRevision) this.bogosRefreshPending = true;
			this.bogosRefreshInFlight = false;
			if (this.bogosRefreshPending) this.refreshBogosCart();
		}
	},

	// Restore the shopper's place after replacing the cart's contents.
	preserveCartView: function (cartElement) {
		const wrapper = cartElement.querySelector(".c-cart__wrapper");
		const scrollTop = wrapper?.scrollTop || 0;
		const focusedControl = cartElement.contains(document.activeElement)
			? document.activeElement
			: null;
		const focusedRow = focusedControl?.closest(".c-line-item[data-item-key]");

		return () => {
			if (focusedControl) {
				const rows = Array.from(cartElement.querySelectorAll(".c-line-item"));
				const matchingRow =
					focusedRow &&
					rows.find(
						(row) => row.dataset.itemKey === focusedRow.dataset.itemKey
					);
				const scope = focusedRow ? matchingRow : cartElement;
				const attributes = [
					"name",
					"type",
					"data-trigger",
					"aria-label",
					"href",
				];
				const replacement = focusedControl.isConnected
					? focusedControl
					: Array.from(
							scope?.querySelectorAll(
								"button, input, select, textarea, a[href], [tabindex]"
							) || []
						).find(
							(control) =>
								control.tagName === focusedControl.tagName &&
								attributes.every(
									(attribute) =>
										control.getAttribute(attribute) ===
										focusedControl.getAttribute(attribute)
								) &&
								(!focusedControl.matches(
									"input[type=radio], input[type=checkbox]"
								) ||
									control.value === focusedControl.value)
						);
				if (replacement && !replacement.disabled)
					replacement.focus({ preventScroll: true });
				if (!replacement || document.activeElement !== replacement) {
					const fallback = cartElement.querySelector(
						".js-minicart-close:not(:disabled)"
					);
					if (!fallback) cartElement.setAttribute("tabindex", "-1");
					(fallback || cartElement).focus({ preventScroll: true });
				}
			}
			const nextWrapper = cartElement.querySelector(".c-cart__wrapper");
			if (nextWrapper) nextWrapper.scrollTop = scrollTop;
		};
	},

	applyCartHtml: function (dataHtml) {
		if (this.pendingQuantityInputs.size) {
			this.bogosRefreshPending = true;
			return;
		}
		const cartContent = dataHtml.querySelector(".c-cart");
		if (!cartContent) return;
		const restoreViews = [];
		// Persist membership accordion expanded state across innerHTML swap.
		// Capture the inline height now — the incoming Liquid HTML renders the
		// accordion collapsed with no inline height to reapply.
		const membershipAccordion = document.querySelector(
			".c-cart__summary__membership .comp-accordion.is-expanded"
		);
		const membershipAccordionExpanded = !!membershipAccordion;
		const membershipAccordionHeight = membershipAccordion
			? membershipAccordion.querySelector(".accordion-content")?.style.height
			: null;
		document.querySelectorAll(".c-cart").forEach((cartElement) => {
			restoreViews.push(this.preserveCartView(cartElement));
			// Preserve the live .js-upsell node across the swap so its slides
			// (including any mid-animation collapse) survive the innerHTML rewrite.
			const liveUpsell = cartElement.querySelector(".js-upsell");
			cartElement.innerHTML = cartContent.innerHTML;
			if (liveUpsell) {
				const incomingUpsell = cartElement.querySelector(".js-upsell");
				if (incomingUpsell) incomingUpsell.replaceWith(liveUpsell);
			}

			// Reapply membership accordion expanded state.
			if (membershipAccordionExpanded) {
				const accordion = cartElement.querySelector(
					".c-cart__summary__membership .comp-accordion"
				);
				const content = accordion?.querySelector(".accordion-content");
				if (accordion && content) {
					accordion.classList.add("is-expanded");
					accordion.setAttribute("aria-expanded", "true");
					content.setAttribute("aria-hidden", "false");
					// Use the captured height — the freshly-swapped accordion content
					// is collapsed and has no inline height to measure.
					content.style.height = membershipAccordionHeight || "auto";
				}
			}
		});

		document.dispatchEvent(new CustomEvent("cart:applied"));

		this.initLineItem();
		this.rescueDisabledSelections();
		this.updateCartLineItemMemberState();
		this.initUpsell();
		restoreViews.forEach((restoreView) => restoreView());
	},

	async updateCartContent(
		cartData,
		{ revision = this.cartRevision, background = false } = {}
	) {
		if (revision !== this.cartRevision) return;
		if (!background) cartUpdating.start();
		try {
			// Use Shopify's Section Rendering API to fetch only the minicart
			// section HTML instead of the full /cart page — dramatically smaller
			// response and faster server render.
			const data = await this.cartJson("/?sections=global-minicart");
			if (revision !== this.cartRevision) return;
			const sectionHtml = data?.["global-minicart"];
			if (sectionHtml) this.applyCartHtml(parseHtmlString(sectionHtml));
		} catch (error) {
			// This is the function every failure path calls to resync with the
			// server, so when it fails the cart on screen is knowingly stale. Say so
			// — silently leaving a wrong cart is what made the original bug invisible.
			console.error("Cart not resynced, display may be stale:", error);
		} finally {
			if (!background) cartUpdating.end();
		}

		await this.updateCartStats(cartData, revision);
	},

	// *** line item level actions ***
	getLineItem: function (el) {
		const item = el.closest(".c-line-item");
		return { item, key: item.dataset.itemKey };
	},

	// Exact line-item identifiers currently in the cart: line keys, item ids and
	// variant ids. Callers must send ONLY exact matches to /cart/update.js.
	//
	// A rendered line key goes stale whenever the line's properties or discount
	// applications change (per Shopify's Cart API docs), and the endpoint then
	// falls back to resolving the key by its variant prefix. When two lines share
	// a variant — a regular line plus a member or gift line, which is
	// routine here — that fallback removes the WRONG line and still returns 200.
	// Verified against the live endpoint, so a stale key is destructive to send,
	// not merely useless.
	liveCartIds: async function () {
		const cart = await this.cartJson("/cart.js");
		return new Set(
			cart.items.flatMap((cartItem) => [
				cartItem.key,
				String(cartItem.id),
				String(cartItem.variant_id),
			])
		);
	},

	// Keys for every membership-related line item to remove together. Reads the
	// fresh server-rendered cart markup (which knows the members_only metafield —
	// /cart.js does not, and the live DOM can be stale across tabs) for membership
	// and members-only flags, plus /cart.js Type matching for complimentary
	// items that have no line-item node. Returns the deduped union.
	// Throws if either read fails — callers must handle it, because both of them
	// have already put the UI into a transitional state by this point.
	membershipCleanupKeys: async function ({ includeMembersOnly }) {
		const [sectionData, cart] = await Promise.all([
			this.cartJson("/?sections=global-minicart"),
			this.cartJson("/cart.js"),
		]);
		const cartHtml = parseHtmlString(sectionData["global-minicart"] || "");
		const flaggedElements = [
			...cartHtml.querySelectorAll("[data-membership]"),
			...(includeMembersOnly
				? cartHtml.querySelectorAll("[data-item-members-only]")
				: []),
		];
		const membershipCartKeys = cart.items
			.filter((cartItem) => {
				const itemType = cartItem.properties?.Type;
				return itemType === "Member Product" || itemType === "Membership";
			})
			.map((cartItem) => cartItem.key);
		return [
			...new Set([
				...flaggedElements.map((el) => el.dataset.itemKey),
				...membershipCartKeys,
			]),
		].filter(Boolean);
	},

	// Signing out from Shopify's hosted account page never reaches the
	// .js-account-logout handler, so the next page load can find members-only
	// items with nothing left to unlock them. Clear them (and any orphaned
	// complimentary items) here. Never blocks the page: failures only log.
	clearOrphanedMembersOnlyItems: async function () {
		if (
			root.classList.contains("is-login-member") ||
			root.classList.contains("cart-has-membership") ||
			!document.querySelector("[data-item-members-only]")
		) {
			return;
		}

		try {
			const variantKeys = await this.membershipCleanupKeys({
				includeMembersOnly: true,
			});
			if (variantKeys.length === 0) return;

			await this.updateLineItems({
				items: Object.fromEntries(variantKeys.map((key) => [key, 0])),
				updateCartContent: true,
				callback: () => {
					updateProductFormsCards();
					document.dispatchEvent(new CustomEvent("bandit:membership-changed"));
				},
			});
		} catch (error) {
			console.error("Members-only cart cleanup skipped:", error);
		}
	},

	getItemData: function (el) {
		const id = el.querySelector('[name="id"]').value;
		const quantity = el.querySelector('[name="quantity"]')?.value || 1;
		const inputSellingPlan = el.querySelector(
			'[name="selling_plan"]:not(:disabled)'
		);
		const properties = {};

		el.querySelectorAll('[name*="properties["]').forEach((el) => {
			const propertyName = el.name.match(/\[(.*?)\]/)[1];
			if (el.value) properties[propertyName] = el.value;
		});

		return {
			id,
			quantity,
			selling_plan: inputSellingPlan ? inputSellingPlan.value : null,
			properties,
		};
	},

	async addItems({
		items,
		updateCartContent = true,
		updateCartStats = false,
		callback,
		onError,
	}) {
		const revision = ++this.cartRevision;
		this.cartMutationsInFlight++;
		cartUpdating.start();
		// Keeps a throwing callback from being mistaken for a failed request.
		let succeeded = false;
		try {
			// Drop blank ids: /cart/add.js is atomic, so one 422s the whole batch.
			const validItems = items.filter((item) => item && item.id);

			// Request the rendered minicart section in the same roundtrip via
			// Section Rendering API, removing the need for a separate /cart fetch.
			const response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({
					items: validItems,
					sections: "global-minicart",
					sections_url: "/cart",
				}),
			});
			const data = await response.json();

			// /cart/add.js is atomic: nothing was added, so don't run the success
			// callback — its follow-up work assumes the new line exists.
			if (!response.ok) {
				console.error(
					"Cart add failed:",
					data?.description || data?.message || response.status
				);
				if (onError) onError(data);
				return;
			}

			const sectionHtml = data?.sections?.["global-minicart"];

			if (revision === this.cartRevision) {
				if (updateCartContent && sectionHtml) {
					this.applyCartHtml(parseHtmlString(sectionHtml));
					this.updateCartStats(undefined, revision);
				} else if (updateCartContent) {
					await this.updateCartContent(undefined, { revision });
				} else if (updateCartStats) {
					this.updateCartStats(undefined, revision);
				}
			}
			succeeded = true;
			if (callback) callback();
		} catch (error) {
			console.error("Error:", error);
			if (!succeeded && onError) onError(error);
		} finally {
			cartUpdating.end();
			this.cartMutationsInFlight--;
			this.refreshBogosCart();
		}
	},

	async updateLineItems({
		items,
		updateCartContent = false,
		updateCartStats = true,
		callback,
		onError,
	}) {
		const revision = ++this.cartRevision;
		this.cartMutationsInFlight++;
		if (updateCartContent) cartUpdating.start();
		// Keeps a throwing callback from being mistaken for a failed request.
		let succeeded = false;
		try {
			// When we need HTML too, request the section in the same call.
			const body = { updates: items };
			if (updateCartContent) {
				body.sections = "global-minicart";
				body.sections_url = "/cart";
			}

			const response = await fetch("/cart/update.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify(body),
			});
			const data = await response.json();

			// /cart/update.js is atomic: a 422 (e.g. one stale line key) means
			// NOTHING was updated. Roll the UI back to server truth — falling
			// through would repaint the cart as if the update had succeeded.
			if (!response.ok) {
				console.error(
					"Cart update failed:",
					data?.description || data?.message || response.status
				);
				if (onError) onError(data);
				await this.updateCartContent(undefined, { revision });
				return;
			}

			const sectionHtml = data?.sections?.["global-minicart"];

			if (revision === this.cartRevision) {
				if (updateCartContent && sectionHtml) {
					this.applyCartHtml(parseHtmlString(sectionHtml));
					this.updateCartStats(data, revision);
				} else if (updateCartContent) {
					await this.updateCartContent(undefined, { revision });
				} else if (updateCartStats) {
					this.updateCartStats(data, revision);
				}
			}

			succeeded = true;
			if (callback) callback();
		} catch (error) {
			console.error("Error:", error);
			if (!succeeded) {
				if (onError) onError(error);
				await this.updateCartContent(undefined, { revision });
			}
		} finally {
			if (updateCartContent) cartUpdating.end();
			this.cartMutationsInFlight--;
			this.refreshBogosCart();
		}
	},

	// *** upsell ***
	isUpsellInit: false,
	// Used by restoreUpsellItem.
	upsellProductHandles: [],
	upsellEmbla: null,
	// Server-rendered pool HTML; source of truth for re-inserts.
	upsellPoolSnapshot: null,
	// Product IDs whose recommendations have been fetched into the pool.
	upsellSeedIds: new Set(),
	// True when the pool was built via API (not server-rendered collections).
	upsellIsApiPool: false,
	// Guard against concurrent initUpsell runs racing on rapid cart updates.
	upsellRefreshInFlight: false,

	// Runs on every cart change; first-time work gated by isUpsellInit.
	initUpsell: async function () {
		const upsell = document.querySelector(".js-upsell");
		if (!upsell) return;

		const mode = upsell.dataset.upsellMode || "slider";
		const upsellItemList = document.querySelector(".js-upsell-item-list");
		// First-init fallback only: empty pool → fetch Shopify recs. Post-init
		// emptiness means the user added everything, so leave it hidden.
		if (
			!this.isUpsellInit &&
			upsellItemList &&
			upsellItemList.querySelector(".js-upsell-item-form") == null
		) {
			await this.createUpsell(upsellItemList, mode);
		}

		if (!this.isUpsellInit) {
			this.applyRandomUpsell(upsellItemList);
			this.isUpsellInit = true;
			this.storeUpsellProducts();
			this.initUpsellNav(mode);
		}

		if (this.upsellIsApiPool && !this.upsellRefreshInFlight) {
			const currentSeedIds = this.getEligibleSeedIds();
			const currentSeedSet = new Set(currentSeedIds);
			// Drop seeds no longer in cart so re-adding an item re-fetches.
			this.upsellSeedIds.forEach((id) => {
				if (!currentSeedSet.has(id)) this.upsellSeedIds.delete(id);
			});
			// Seeds added via collapseUpsellSlide are already in upsellSeedIds,
			// so internal upsell-adds get filtered out here. Only external adds
			// (PDP, product card, etc.) survive as "new".
			const newSeedIds = currentSeedIds.filter(
				(id) => !this.upsellSeedIds.has(id)
			);
			if (newSeedIds.length > 0) {
				this.upsellRefreshInFlight = true;
				try {
					await this.refreshUpsellWithNewSeeds(newSeedIds, mode);
					newSeedIds.forEach((id) => this.upsellSeedIds.add(id));
				} finally {
					this.upsellRefreshInFlight = false;
				}
			}
		}

		this.ensureUpsellRackFilled();
		this.toggleUpsellVisibility(this.getVisibleUpsellItems());

		// Don't reInit Embla mid-collapse; the transitionend handler will.
		if (
			mode === "slider" &&
			!document.querySelector(".js-upsell-slide.is-removing")
		) {
			this.initOrReInitUpsellEmbla();
		}
	},
	// Self-heal the rack after a cart change: reap orphaned cards whose product
	// is now in cart, then refill from the pool. If the remaining eligible set
	// fits in the open slots, surface all of it; otherwise top up to target.
	ensureUpsellRackFilled: function () {
		const upsell = document.querySelector(".js-upsell");
		const itemList = document.querySelector(".js-upsell-item-list");
		if (!upsell || !itemList || !this.upsellPoolSnapshot) return;

		const mode = upsell.dataset.upsellMode || "slider";
		const target = parseInt(upsell.dataset.upsellRandomCount, 10) || 0;

		const cartHandles = new Set(
			[...document.querySelectorAll(".js-line-item")].map((el) =>
				el.getAttribute("data-product-handle")
			)
		);
		// Mid-collapse forms count as "in cart": the API ack may lag the cart
		// re-render, and we must not re-insert them from the snapshot.
		[...itemList.querySelectorAll(".js-upsell-item-form[data-collapsing]")]
			.map((f) => f.getAttribute("data-product-handle"))
			.filter(Boolean)
			.forEach((h) => cartHandles.add(h));

		// Reap orphans whose cleanup hook didn't run. Mid-collapse slides keep
		// animating themselves out.
		[...itemList.querySelectorAll(".js-upsell-item-form")].forEach((form) => {
			if (form.dataset.collapsing) return;
			const handle = form.getAttribute("data-product-handle");
			if (handle && cartHandles.has(handle)) {
				const slide = form.closest(".js-upsell-slide");
				(slide || form).remove();
			}
		});

		const displayedHandles = new Set(
			[...itemList.querySelectorAll(".js-upsell-item-form")]
				.filter((f) => !f.dataset.collapsing)
				.map((f) => f.getAttribute("data-product-handle"))
		);

		const eligible = this.getEligibleUpsellNodes(
			mode,
			cartHandles,
			displayedHandles
		);
		if (eligible.length === 0) return;

		const slotsToFill =
			target > 0
				? Math.max(0, target - displayedHandles.size)
				: eligible.length;
		const insertCount = Math.min(eligible.length, slotsToFill);

		for (let i = 0; i < insertCount; i++) {
			this.insertUpsellWithEnterAnimation(eligible[i], mode);
		}
	},
	// Collapse a card horizontally. Lock the inner card width so its contents
	// don't reflow as the outer slide shrinks (otherwise images/text wrap and
	// push the arrows down).
	collapseUpsellSlide: function (form) {
		if (!form || form.dataset.collapsing) return;
		const slide = form.closest(".js-upsell-slide") || form;
		const upsell = slide.closest(".js-upsell");
		form.dataset.collapsing = "1";

		// Preempt seed tracking: the just-added product is about to appear as a
		// cart line item. Recording its ID here prevents the next initUpsell
		// from treating it as an external add and refetching recommendations.
		const addedProductId = form.getAttribute("data-product-id");
		if (addedProductId) this.upsellSeedIds.add(addedProductId);

		const isSlider = upsell?.dataset.upsellMode !== "stack";
		const rect = slide.getBoundingClientRect();
		if (isSlider) {
			slide.style.width = rect.width + "px";
			slide.style.flex = "0 0 " + rect.width + "px";
			const inner = slide.firstElementChild;
			if (inner && inner !== slide) inner.style.width = rect.width + "px";
		} else {
			slide.style.maxHeight = rect.height + "px";
		}

		void slide.offsetWidth; // force reflow so transition has a start value
		slide.classList.add("is-removing");
		// Update is-only-one-upsell-item now so the survivor grows in parallel.
		this.toggleUpsellVisibility(this.getVisibleUpsellItems());

		let finished = false;
		const finish = () => {
			if (finished) return;
			finished = true;
			slide.removeEventListener("transitionend", onEnd);
			clearTimeout(fallback);
			slide.remove();
			this.rotateNextUpsell();
			this.toggleUpsellVisibility(this.getVisibleUpsellItems());
			if (upsell?.dataset.upsellMode !== "stack")
				this.initOrReInitUpsellEmbla();
		};
		const onEnd = (e) => {
			if (e.target !== slide) return;
			if (e.propertyName !== "width" && e.propertyName !== "max-height") return;
			finish();
		};
		slide.addEventListener("transitionend", onEnd);
		// Fallback: if the cart re-render detaches the slide mid-transition,
		// transitionend never fires and the slide stays at size 0 in the DOM.
		const fallback = setTimeout(finish, 500);
	},
	getVisibleUpsellItems: function () {
		return [...document.querySelectorAll(".js-upsell-item-form")].filter(
			(form) => {
				if (form.dataset.collapsing) return false;
				const slide = form.closest(".js-upsell-slide");
				if (slide?.classList.contains("is-removing")) return false;
				return true;
			}
		);
	},
	// Slide the next pool card in after a collapse. If the remaining pool fits
	// the open slots, surface all of it; otherwise top up by one.
	rotateNextUpsell: function () {
		const upsell = document.querySelector(".js-upsell");
		const itemList = document.querySelector(".js-upsell-item-list");
		if (!upsell || !itemList) return;
		const mode = upsell.dataset.upsellMode || "slider";

		const target = parseInt(upsell.dataset.upsellRandomCount, 10) || 0;
		const currentCount = itemList.querySelectorAll(
			".js-upsell-item-form"
		).length;
		if (target > 0 && currentCount >= target) return;

		const cartHandles = new Set(
			[...document.querySelectorAll(".js-line-item")].map((el) =>
				el.getAttribute("data-product-handle")
			)
		);
		const displayedHandles = new Set(
			[...itemList.querySelectorAll(".js-upsell-item-form")].map((f) =>
				f.getAttribute("data-product-handle")
			)
		);

		const eligible = this.getEligibleUpsellNodes(
			mode,
			cartHandles,
			displayedHandles
		);
		if (eligible.length === 0) return;

		const slotsToFill = target > 0 ? Math.max(0, target - currentCount) : 1;
		const insertCount = eligible.length <= slotsToFill ? eligible.length : 1;

		for (let i = 0; i < insertCount; i++) {
			this.insertUpsellWithEnterAnimation(eligible[i], mode);
		}
	},
	// Pool nodes not in cart and not currently displayed, in pool order.
	getEligibleUpsellNodes: function (mode, cartHandles, displayedHandles) {
		if (!this.upsellPoolSnapshot) return [];
		const wrapper = document.createElement("div");
		wrapper.innerHTML = this.upsellPoolSnapshot;
		const poolNodes =
			mode === "slider"
				? [...wrapper.querySelectorAll(".js-upsell-slide")]
				: [...wrapper.querySelectorAll(".js-upsell-item-form")];
		return poolNodes.filter((node) => {
			const form = node.classList.contains("js-upsell-item-form")
				? node
				: node.querySelector(".js-upsell-item-form");
			const handle = form?.getAttribute("data-product-handle");
			return (
				handle && !cartHandles.has(handle) && !displayedHandles.has(handle)
			);
		});
	},
	// Mirror of collapseUpsellSlide. Inner card width is locked so contents
	// don't reflow as the outer expands.
	insertUpsellWithEnterAnimation: function (node, mode) {
		const itemList = document.querySelector(".js-upsell-item-list");
		if (!itemList) return;
		const isSlider = mode === "slider";

		let targetWidth = null;
		if (isSlider) {
			const sibling = itemList.querySelector(".js-upsell-slide");
			if (sibling) targetWidth = sibling.getBoundingClientRect().width;
			// Empty list (e.g. restoring after section was hidden): no sibling to
			// measure. Append without entrance animation so the slide is visible
			// instead of getting stuck at width 0.
			if (!targetWidth) {
				itemList.appendChild(node);
				this.toggleUpsellVisibility(this.getVisibleUpsellItems());
				this.initOrReInitUpsellEmbla();
				return;
			}
		}

		if (isSlider && targetWidth) {
			node.style.width = "0px";
			node.style.flex = "0 0 0";
			node.style.marginInline = "0";
			node.style.opacity = "0";
			const inner = node.firstElementChild;
			if (inner && inner !== node) inner.style.width = targetWidth + "px";
		} else {
			node.style.maxHeight = "0";
			node.style.opacity = "0";
		}

		itemList.appendChild(node);
		void node.offsetWidth; // force start state

		requestAnimationFrame(() => {
			if (isSlider && targetWidth) {
				node.style.width = targetWidth + "px";
				node.style.flex = "0 0 " + targetWidth + "px";
				node.style.marginInline = "";
				node.style.opacity = "1";
			} else {
				node.style.maxHeight = "";
				const h = node.getBoundingClientRect().height;
				node.style.maxHeight = "0";
				void node.offsetWidth;
				requestAnimationFrame(() => {
					node.style.maxHeight = h + "px";
					node.style.opacity = "1";
				});
			}
		});

		const onEnd = (e) => {
			if (e.target !== node) return;
			if (e.propertyName !== "width" && e.propertyName !== "max-height") return;
			node.removeEventListener("transitionend", onEnd);
			node.style.width = "";
			node.style.flex = "";
			node.style.marginInline = "";
			node.style.opacity = "";
			node.style.maxHeight = "";
			const inner = node.firstElementChild;
			if (inner && inner !== node) inner.style.width = "";
			// Refresh classes so isOnlyOne reflects the new count before reInit.
			this.toggleUpsellVisibility(this.getVisibleUpsellItems());
			if (isSlider) this.initOrReInitUpsellEmbla();
		};
		node.addEventListener("transitionend", onEnd);
	},
	// Randomly pick N items from the server-rendered pool. Snapshot on first
	// run so subsequent calls re-shuffle from the full pool, not the trimmed DOM.
	applyRandomUpsell: function (itemList) {
		if (!itemList) return;
		const upsell = document.querySelector(".js-upsell");
		const n = parseInt(upsell?.dataset.upsellRandomCount, 10) || 0;
		if (n <= 0) return;

		if (this.upsellPoolSnapshot === null) {
			this.upsellPoolSnapshot = itemList.innerHTML;
		} else {
			itemList.innerHTML = this.upsellPoolSnapshot;
		}

		const children = [...itemList.children];
		if (children.length <= n) return;

		for (let i = children.length - 1; i > 0; i--) {
			const j = getRandomInt(0, i + 1);
			[children[i], children[j]] = [children[j], children[i]];
		}

		itemList.innerHTML = "";
		children.slice(0, n).forEach((c) => itemList.appendChild(c));
	},
	// Embla doesn't observe DOM mutations; reInit after slide changes,
	// rebuild if the viewport node was replaced.
	initOrReInitUpsellEmbla: function () {
		const viewport = document.querySelector(".js-upsell-viewport");
		if (!viewport || typeof EmblaCarousel === "undefined") return;

		const isOnlyOne = document
			.querySelector(".js-upsell")
			?.classList.contains("is-only-one-upsell-item");

		const options = {
			align: "start",
			loop: !isOnlyOne,
			skipSnaps: true,
			duration: 12,
			watchDrag: !isOnlyOne,
		};

		if (this.upsellEmbla) {
			if (this.upsellEmbla.rootNode() === viewport) {
				this.upsellEmbla.reInit(options);
				return;
			}
			this.upsellEmbla.destroy();
			this.upsellEmbla = null;
		}

		this.upsellEmbla = EmblaCarousel(viewport, options);
	},
	// Must match sections/upsell-recommendations.liquid filename.
	upsellSectionId: "upsell-recommendations",
	upsellMinCount: 3,

	hasSkippedTag: function (tagsAttr, skipTags) {
		if (skipTags.length === 0) return false;
		const tags = (tagsAttr || "")
			.split(",")
			.map((t) => t.trim().toLowerCase())
			.filter(Boolean);
		return skipTags.some((skip) => tags.includes(skip));
	},
	// Split on newlines (not commas) — tag values may contain commas.
	getUpsellSkipTags: function () {
		return (document.querySelector(".js-upsell")?.dataset.skipTags || "")
			.split("\n")
			.map((t) => t.trim().toLowerCase())
			.filter(Boolean);
	},
	// Target pool size for API fetches. Aims for upsell_random_count items
	// (so the random shuffle has something to trim), with upsellMinCount as
	// a floor and eligibleCount as another floor for variety.
	getUpsellTargetCount: function (eligibleCount) {
		const desired =
			parseInt(
				document.querySelector(".js-upsell")?.dataset.upsellRandomCount,
				10
			) || 0;
		return Math.max(this.upsellMinCount, desired, eligibleCount);
	},
	// Membership / membership-gift lines aren't user-picked, so they're
	// excluded as recommendation seeds.
	createUpsell: async function (upsellItemList, mode) {
		const allLineItems = [...document.querySelectorAll(".js-line-item")];
		const eligibleLineItems = allLineItems.filter(
			(el) =>
				!el.hasAttribute("data-membership") &&
				!el.hasAttribute("data-membership-gift")
		);
		const seedIds = eligibleLineItems.map((el) =>
			el.getAttribute("data-product-id")
		);

		if (allLineItems.length === 0 || seedIds.length === 0) return;

		const targetCount = this.getUpsellTargetCount(eligibleLineItems.length);
		const upsellCards = await this.fetchUpsellItems(seedIds, targetCount);

		if (upsellCards.length === 0) return;

		upsellCards.forEach((card) => {
			if (mode === "slider") {
				const slide = document.createElement("div");
				slide.className = "embla__slide js-upsell-slide";
				slide.appendChild(card);
				upsellItemList?.appendChild(slide);
			} else {
				upsellItemList?.appendChild(card);
			}
		});
		this.upsellIsApiPool = true;
		seedIds.forEach((id) => this.upsellSeedIds.add(id));
		this.storeUpsellProducts();

		return upsellCards;
	},
	// Take each seed's top pick before any seed's second pick, then
	// slice to targetCount.
	fetchUpsellItems: async function (seedIds, targetCount) {
		if (seedIds.length === 0) return [];

		const skipTags = this.getUpsellSkipTags();
		const lineItemHandles = [...document.querySelectorAll(".js-line-item")].map(
			(el) => el.getAttribute("data-product-handle")
		);

		const cardsPerLine = await Promise.all(
			seedIds.map((id) => this.fetchUpsellCardsForProduct(id, targetCount))
		);

		const interleaved = [];
		const maxLen = Math.max(0, ...cardsPerLine.map((c) => c.length));
		for (let i = 0; i < maxLen; i++) {
			for (const cards of cardsPerLine) {
				if (cards[i]) interleaved.push(cards[i]);
			}
		}

		const seenHandles = new Set();
		const uniqueCards = [];
		interleaved.forEach((card) => {
			const handle = card.getAttribute("data-product-handle");
			if (!handle || seenHandles.has(handle)) return;
			if (lineItemHandles.includes(handle)) return;
			if (this.hasSkippedTag(card.dataset.productTags, skipTags)) return;
			seenHandles.add(handle);
			uniqueCards.push(card);
		});

		return uniqueCards.slice(0, targetCount);
	},
	// Uses Section Rendering API so cards match server-rendered markup.
	fetchUpsellCardsForProduct: async function (productId, limit) {
		const limitParam = limit ? `&limit=${limit}` : "";
		const url =
			window.Shopify.routes.root +
			`recommendations/products?section_id=${this.upsellSectionId}` +
			`&product_id=${productId}&intent=related${limitParam}`;
		const response = await fetch(url);
		if (!response.ok) return [];
		const html = await response.text();
		const wrapper = document.createElement("div");
		wrapper.innerHTML = html;
		return [...wrapper.querySelectorAll(".js-upsell-item-form")];
	},
	toggleUpsellVisibility: function (upsellItems) {
		const upsell = document.querySelector(".js-upsell");
		if (!upsell) return;

		upsell.classList.toggle("has-upsell-items", upsellItems?.length > 0);
		upsell.classList.toggle(
			"is-only-one-upsell-item",
			upsellItems?.length === 1
		);
	},
	// Delegated on body so arrows survive cart re-renders.
	initUpsellNav: function (mode) {
		if (mode === "slider") {
			on("body", "click", ".js-upsell-arrow-left", () =>
				this.upsellEmbla?.scrollPrev()
			);
			on("body", "click", ".js-upsell-arrow-right", () =>
				this.upsellEmbla?.scrollNext()
			);
		}
	},
	// Slide a removed cart item back into the upsell rack — only if it was in
	// the original pool. May overshoot upsell_random_count temporarily; the
	// rack resamples on next page load.
	restoreUpsellItem: function (item) {
		const upsell = document.querySelector(".js-upsell");
		if (!upsell || !this.upsellPoolSnapshot) return;

		const handle = item.getAttribute("data-product-handle");
		if (!this.upsellProductHandles.includes(handle)) return;

		// Already displayed (defensive) — don't duplicate.
		if (
			document.querySelector(
				`.js-upsell-item-list .js-upsell-item-form[data-product-handle="${CSS.escape(handle)}"]`
			)
		) {
			return;
		}

		const mode = upsell.dataset.upsellMode || "slider";
		const node = this.findUpsellPoolNode(handle, mode);
		if (!node) return;

		this.insertUpsellWithEnterAnimation(node, mode);
		this.toggleUpsellVisibility(this.getVisibleUpsellItems());
	},
	findUpsellPoolNode: function (handle, mode) {
		if (!this.upsellPoolSnapshot) return null;
		const wrapper = document.createElement("div");
		wrapper.innerHTML = this.upsellPoolSnapshot;
		const selector =
			mode === "slider" ? ".js-upsell-slide" : ".js-upsell-item-form";
		return [...wrapper.querySelectorAll(selector)].find((n) => {
			const form = n.classList.contains("js-upsell-item-form")
				? n
				: n.querySelector(".js-upsell-item-form");
			return form?.getAttribute("data-product-handle") === handle;
		});
	},
	// Snapshot ALL pool handles (from the server-rendered snapshot, not the
	// trimmed DOM), so restoreUpsellItem works for items rotated in after init.
	storeUpsellProducts: function () {
		if (this.upsellProductHandles.length > 0) return;
		this.refreshUpsellProductHandles();
	},

	// Re-reads pool handles from the current snapshot. Called whenever the
	// snapshot is extended (e.g. by refreshUpsellWithNewSeeds) so that
	// restoreUpsellItem can find API-added cards too.
	refreshUpsellProductHandles: function () {
		if (!this.upsellPoolSnapshot) {
			this.upsellProductHandles = [
				...document.querySelectorAll(".js-upsell-item-form"),
			].map((item) => item.getAttribute("data-product-handle"));
			return;
		}
		const wrapper = document.createElement("div");
		wrapper.innerHTML = this.upsellPoolSnapshot;
		this.upsellProductHandles = [
			...wrapper.querySelectorAll(".js-upsell-item-form"),
		].map((item) => item.getAttribute("data-product-handle"));
	},

	getEligibleSeedIds: function () {
		return [...document.querySelectorAll(".js-line-item")]
			.filter(
				(el) =>
					!el.hasAttribute("data-membership") &&
					!el.hasAttribute("data-membership-gift")
			)
			.map((el) => el.getAttribute("data-product-id"))
			.filter(Boolean);
	},

	// Extends the pool snapshot only; does NOT modify the visible rack.
	// ensureUpsellRackFilled will pull new cards in when slots open up,
	// so existing visible cards keep their state (variant selectors, etc.).
	refreshUpsellWithNewSeeds: async function (newSeedIds, mode) {
		const targetCount = this.getUpsellTargetCount(newSeedIds.length);
		const newCards = await this.fetchUpsellItems(newSeedIds, targetCount);
		if (newCards.length === 0) return;

		const wrapper = document.createElement("div");
		if (this.upsellPoolSnapshot) wrapper.innerHTML = this.upsellPoolSnapshot;

		const existingHandles = new Set(
			[...wrapper.querySelectorAll(".js-upsell-item-form")]
				.map((f) => f.getAttribute("data-product-handle"))
				.filter(Boolean)
		);

		const deduped = newCards.filter((card) => {
			const h = card.getAttribute("data-product-handle");
			return h && !existingHandles.has(h);
		});
		if (deduped.length === 0) return;

		deduped.forEach((card) => {
			if (mode === "slider") {
				const slide = document.createElement("div");
				slide.className = "embla__slide js-upsell-slide";
				slide.appendChild(card);
				wrapper.appendChild(slide);
			} else {
				wrapper.appendChild(card);
			}
		});

		this.upsellPoolSnapshot = wrapper.innerHTML;
		this.refreshUpsellProductHandles();
	},

	// *** line item level updates ***
	isLineItemEventAttached: false,
	initLineItem: function () {
		const getItemKeyWithQuantity = (itemKey, quantity) => ({
			[itemKey]: quantity,
		});

		const QUANTITY_DEBOUNCE_MS = 300;
		const quantityTimers = new WeakMap();

		document
			.querySelectorAll('.c-line-item input[name="quantity"]')
			.forEach((el) => {
				el.addEventListener("change", (e) => {
					const target = e.target.closest('input[name="quantity"]');
					const item = e.target.closest(".c-line-item");
					if (!item) return;
					// Protect the edit before its debounced request starts.
					++this.cartRevision;
					this.pendingQuantityInputs.add(target);

					// Optimistic free-shipping update — runs synchronously before debounce
					const prevQty = parseInt(
						target.dataset.prevQuantity ?? target.defaultValue
					);
					const newQty = parseInt(target.value);
					const unit = parseFloat(item.dataset.unitPrice);
					if (
						Number.isFinite(unit) &&
						Number.isFinite(prevQty) &&
						Number.isFinite(newQty)
					) {
						if (item.hasAttribute("data-gift-main-id")) {
							const mainId = item.dataset.giftMainId;
							const giftItems = Array.from(
								document.querySelectorAll(`[data-gift-main-id="${mainId}"]`)
							);
							const giftDelta =
								giftItems.reduce((sum, el) => {
									if (el.hasAttribute("data-pickup-only")) return sum;
									const u = parseFloat(el.dataset.unitPrice);
									return sum + (Number.isFinite(u) ? u : 0);
								}, 0) *
								(newQty - prevQty);
							this.applyOptimisticFreeShipping(giftDelta);
						} else if (!item.hasAttribute("data-pickup-only")) {
							this.applyOptimisticFreeShipping((newQty - prevQty) * unit);
						}
					}
					target.dataset.prevQuantity = newQty;
					item.dataset.quantity = newQty;

					clearTimeout(quantityTimers.get(target));
					const timer = setTimeout(() => {
						this.pendingQuantityInputs.delete(target);
						if (!target.isConnected) {
							this.refreshBogosCart();
							return;
						}
						const quantity = parseInt(target.value) || 1;

						if (item.hasAttribute("data-gift-main-id")) {
							const mainId = item.dataset.giftMainId;
							const giftKeys = Array.from(
								document.querySelectorAll(`[data-gift-main-id="${mainId}"]`)
							).map((el) => el.dataset.itemKey);
							return updateMultipleQuantities(giftKeys, quantity);
						}

						const { key } = this.getLineItem(target);
						this.updateLineItems({
							items: getItemKeyWithQuantity(key, quantity),
						});
					}, QUANTITY_DEBOUNCE_MS);
					quantityTimers.set(target, timer);
				});
			});

		if (this.isLineItemEventAttached) return;
		this.isLineItemEventAttached = true;

		const removeMultiple = async (keys, callback, onError) => {
			loader.updateProgress(root);

			// /cart/update.js is atomic: a key whose variant isn't in the cart
			// 422s ("Cannot find variant") and rejects the entire batch — nothing
			// gets removed (verified against the live endpoint). Keep only exact
			// matches; see liveCartIds for why a stale key must never be sent.
			// Dropping one costs the shopper a second click after the resync
			// repaints with current keys.
			let validKeys = keys;
			try {
				const liveIds = await this.liveCartIds();
				validKeys = keys.filter((key) => liveIds.has(String(key)));
			} catch (error) {
				// Best-effort: proceed unvalidated rather than block the removal, but
				// name it — the wrong-line protection is off for this request, so this
				// line matters if a mis-deletion is ever reported.
				console.error(
					"Cart key validation unavailable, sending unvalidated keys:",
					error
				);
			}

			// Already gone server-side: the desired end state holds, so treat this
			// as success and let callers run their post-removal work.
			if (validKeys.length === 0) {
				loader.complete(root);
				this.updateCartContent();
				if (callback) callback();
				return;
			}

			const updates = validKeys.reduce((acc, id) => {
				acc[id] = 0;
				return acc;
			}, {});

			this.updateLineItems({
				items: updates,
				updateCartContent: true,
				updateCartStats: true,
				callback: () => {
					loader.complete(root);
					if (callback) callback();
				},
				onError: () => {
					loader.complete(root);
					if (onError) onError();
				},
			});
		};

		const updateMultipleQuantities = (keys, quantity, afterUpdate) => {
			const updates = keys.reduce((acc, key) => {
				acc[key] = quantity;
				return acc;
			}, {});

			this.updateLineItems({
				items: updates,
				updateCartStats: true,
				callback: afterUpdate,
			});
		};

		// Membership removal
		on("body", "click", ".c-line-item .js-item-remove-trigger", async (e) => {
			const trigger = e.target.closest(".js-item-remove-trigger");
			const item = trigger?.closest(".c-line-item");
			if (!item?.hasAttribute("data-membership")) return;

			e.stopImmediatePropagation();
			root.classList.remove("cart-has-membership");
			// Hold the membership REMOVE → JOIN NOW swap until the removal settles.
			root.classList.add("cart-membership-pending");

			// A logged-in member keeps their members-only items when a cart membership
			// is removed (they're still a member); a non-member loses them too.
			const isLoginMember = root.classList.contains("is-login-member");
			let variantKeys;
			try {
				variantKeys = await this.membershipCleanupKeys({
					includeMembersOnly: !isLoginMember,
				});
			} catch (error) {
				// The two membership classes above were flipped optimistically. If we
				// bail without restoring them the cart is stuck mid-transition, showing
				// neither REMOVE nor JOIN NOW.
				console.error("Membership removal aborted:", error);
				root.classList.add("cart-has-membership");
				root.classList.remove("cart-membership-pending");
				return;
			}

			// Re-fetch PDP/PLP after removal so the unlocked ATC re-gates.
			removeMultiple(
				variantKeys,
				() => {
					requestAnimationFrame(() =>
						requestAnimationFrame(() =>
							root.classList.remove("cart-membership-pending")
						)
					);
					updateProductFormsCards();
					// Re-gate the quick-add panel (clears its cached section HTML).
					document.dispatchEvent(new CustomEvent("bandit:membership-changed"));
				},
				() => {
					root.classList.add("cart-has-membership");
					root.classList.remove("cart-membership-pending");
				}
			);
		});

		// Remove Item
		on("body", "click", ".c-line-item .js-item-remove-trigger", async (e) => {
			const { item, key } = this.getLineItem(e.target);

			if (item.hasAttribute("data-gift-main-id")) {
				const giftItems = Array.from(
					document.querySelectorAll(
						`[data-gift-main-id="${item.dataset.giftMainId}"]`
					)
				);
				const giftDelta = -giftItems.reduce((sum, el) => {
					if (el.hasAttribute("data-pickup-only")) return sum;
					const lp = parseFloat(el.dataset.linePrice);
					return sum + (Number.isFinite(lp) ? lp : 0);
				}, 0);
				this.applyOptimisticFreeShipping(giftDelta);
				return removeMultiple(
					giftItems.map((el) => el.dataset.itemKey),
					undefined,
					() => this.applyOptimisticFreeShipping(-giftDelta)
				);
			}

			const linePrice = parseFloat(item.dataset.linePrice);
			const countsTowardFreeShipping =
				Number.isFinite(linePrice) && !item.hasAttribute("data-pickup-only");
			if (countsTowardFreeShipping) {
				this.applyOptimisticFreeShipping(-linePrice);
			}
			item.classList.add("is-removed");

			const rollback = () => {
				item.classList.remove("is-removed");
				if (countsTowardFreeShipping) {
					this.applyOptimisticFreeShipping(linePrice);
				}
			};

			// The key rendered into this row can be stale. Sending a stale key would
			// remove a different line that shares its variant and still report
			// success (see liveCartIds), so confirm an exact match first and
			// otherwise resync — the repaint supplies a current key to click again.
			try {
				const liveIds = await this.liveCartIds();
				if (!liveIds.has(String(key))) {
					console.error(
						"Cart removal skipped — line key no longer matches the cart:",
						key
					);
					rollback();
					this.updateCartContent();
					return;
				}
			} catch (error) {
				// Best-effort: fall through to the update's own error handling rather
				// than block the removal, but name it — the wrong-line protection is
				// off for this request.
				console.error(
					"Cart key validation unavailable, sending unvalidated key:",
					error
				);
			}

			this.updateLineItems({
				items: getItemKeyWithQuantity(key, 0),
				updateCartContent: true,
				// Post-removal side effects only once the server confirms it — an
				// upsell card restored on a failed removal would show the product in
				// both the rack and the cart row that comes back.
				callback: () => {
					this.restoreUpsellItem(item);

					if (item.classList.contains("is-limited-purchase")) {
						const targetForm = document.querySelector(
							`.c-product-form.is-purchased[data-form-id="${item.dataset.productId}"]`
						);
						if (targetForm) updateAllLimitedPurchaseForms(targetForm);
					}
				},
				onError: rollback,
			});
		});

		// Change Variant
		on("body", "change", ".c-line-item .js-variant-selector", (e) => {
			const target = e.target.closest(".js-variant-selector");
			const { item, key } = this.getLineItem(target);

			if (target.closest(".js-selector-parent")) {
				cProductForm.updateDropdown(target, false);
			}

			cartUpdating.start(item);

			// --- COMBINED LISTINGS AJAX FETCH ---
			if (target.dataset.swatchUrl) {
				const urlObj = new URL(
					target.dataset.swatchUrl,
					window.location.origin
				);

				fetch(urlObj.pathname + ".js")
					.then((res) => res.json())
					.then((productData) => {
						const sizeGroup = item.querySelector(
							'.js-variant-group[class*="size"]'
						);
						const sizeValue =
							sizeGroup?.querySelector(".js-variant-selector:checked")?.value ||
							null;

						let newVariant = null;
						if (sizeValue) {
							newVariant =
								productData.variants.find(
									(v) => v.options.includes(sizeValue) && v.available
								) ||
								productData.variants.find((v) => v.options.includes(sizeValue));
						}
						if (!newVariant) {
							newVariant =
								productData.variants.find((v) => v.available) ||
								productData.variants[0];
						}

						if (!newVariant) {
							cartUpdating.end(item);
							return;
						}

						const itemData = this.getItemData(item);
						itemData.id = newVariant.id;

						if (
							newVariant.inventory_management === "shopify" &&
							parseInt(itemData.quantity) > newVariant.inventory_quantity
						) {
							itemData.quantity = newVariant.inventory_quantity;
						}

						this.addItems({
							items: [itemData],
							updateCartContent: false,
							updateCartStats: false,
							callback: () => {
								this.updateLineItems({
									items: getItemKeyWithQuantity(key, 0),
									callback: () => this.updateCartContent(),
								});
							},
							// The new variant never made it in, so keep the old line.
							onError: () => cartUpdating.end(item),
						});
					})
					.catch((err) => {
						console.error(
							"Failed to fetch combined listing product data:",
							err
						);
						cartUpdating.end(item);
					});

				return;
			}
			// --- END COMBINED LISTINGS FIX ---

			// --- PROXY MEMBERSHIP SOCK VARIANT SWAP ---
			const proxyWrapper = target.closest("[data-proxy-key]");
			if (proxyWrapper) {
				const proxyOldVariantId = parseInt(proxyWrapper.dataset.proxyItemId);

				let proxyVariantsJson = validateJson(
					proxyWrapper.dataset.variantsJson.replace(/'/g, '"').trim()
				);

				if (!proxyVariantsJson) {
					cartUpdating.end(item);
					return;
				}

				const selectedValues = Array.from(
					proxyWrapper.querySelectorAll(".js-variant-group")
				)
					.map(
						(group) =>
							group.querySelector(".js-variant-selector:checked")?.value
					)
					.filter(Boolean);

				const variantTitle = selectedValues.join(" / ");
				let variantIndex = proxyVariantsJson.findIndex(
					(object) => object.title === variantTitle
				);

				if (variantIndex === -1 && target.value) {
					variantIndex = proxyVariantsJson.findIndex(
						(object) =>
							object.title.includes(target.value) && object.inventory > 0
					);
					if (variantIndex === -1)
						variantIndex = proxyVariantsJson.findIndex((object) =>
							object.title.includes(target.value)
						);
				}

				const proxyVariantObject = proxyVariantsJson[variantIndex];
				if (!proxyVariantObject) {
					cartUpdating.end(item);
					return;
				}

				const extraProperties = {};
				if (proxyVariantObject.preorder === "true") {
					extraProperties["Pre-order"] =
						proxyVariantObject.deliveryNote || "Pre-order";
				} else if (proxyVariantObject.comingSoon === "true") {
					extraProperties["Coming Soon"] =
						proxyVariantObject.deliveryNote || "Coming Soon";
				} else if (proxyVariantObject.deliveryNote) {
					extraProperties["Note"] = proxyVariantObject.deliveryNote;
				}

				this.swapLineItemVariant({
					oldVariantId: proxyOldVariantId,
					newVariantId: parseInt(proxyVariantObject.id),
					extraProperties,
					// Release the row explicitly. The resync below normally destroys it
					// (clearing the class with it), but if that read also fails the row
					// would stay greyed out and unclickable.
					callback: () => {
						cartUpdating.end(item);
						this.updateCartContent();
					},
				});
				return;
			}
			// --- END PROXY MEMBERSHIP SOCK VARIANT SWAP ---

			// Standard single-product logic
			let variantsJson = lineItemVariantsCache.get(item);
			if (!variantsJson) {
				variantsJson = validateJson(
					item.dataset.variantsJson.replace(/'/g, '"').trim()
				);
				lineItemVariantsCache.set(item, variantsJson);
			}

			const selectedValues = Array.from(
				item.querySelectorAll(".js-variant-group")
			)
				.map(
					(group) => group.querySelector(".js-variant-selector:checked")?.value
				)
				.filter(Boolean);

			const variantTitle = selectedValues.join(" / ");
			let variantIndex = variantsJson.findIndex(
				(object) => object.title === variantTitle
			);

			if (variantIndex === -1 && target.value) {
				variantIndex = variantsJson.findIndex(
					(object) =>
						object.title.includes(target.value) && object.inventory > 0
				);
				if (variantIndex === -1)
					variantIndex = variantsJson.findIndex((object) =>
						object.title.includes(target.value)
					);
			}

			const variantObject = variantsJson[variantIndex];
			if (!variantObject) {
				cartUpdating.end(item);
				return;
			}

			// Members-only guard
			const isMembersOnlyVariant = variantObject.variantMembersOnly === "true";
			const isMember =
				root.classList.contains("cart-has-membership") ||
				root.classList.contains("is-login-member");
			if (isMembersOnlyVariant && !isMember) {
				cartUpdating.end(item);
				return;
			}

			// Collect preorder/comingSoon/note/membersOnly properties
			const extraProperties = {};
			if (variantObject.preorder === "true") {
				extraProperties["Pre-order"] =
					variantObject.deliveryNote || "Pre-order";
			} else if (variantObject.comingSoon === "true") {
				extraProperties["Coming Soon"] =
					variantObject.deliveryNote || "Coming Soon";
			} else if (variantObject.deliveryNote) {
				extraProperties["Note"] = variantObject.deliveryNote;
			}
			if (isMembersOnlyVariant) {
				extraProperties["Exclusive"] = "Members Only";
			}

			const oldVariantId = parseInt(item.dataset.itemId);
			this.swapLineItemVariant({
				oldVariantId,
				newVariantId: parseInt(variantObject.id),
				extraProperties,
				// See the sibling call above: release the row explicitly so a failed
				// resync can't leave it greyed out and unclickable.
				callback: () => {
					cartUpdating.end(item);
					this.updateCartContent();
				},
			});
		});
	},

	// *** member discount display on cart line items ***
	// Liquid only adds .is-member for logged-in members; this syncs cart-has-membership state.
	// When active: copies js-price-regular into js-price-compare (strikethrough) if compare
	// is currently empty, then toggles .is-member so CSS shows js-price-member and hides regular.
	updateCartLineItemMemberState: function () {
		const isUnlocked =
			root.classList.contains("is-login-member") ||
			root.classList.contains("cart-has-membership");

		document.querySelectorAll(".js-line-item").forEach((lineItem) => {
			// Skip membership and gift items — they have their own price display
			if (
				lineItem.hasAttribute("data-membership") ||
				lineItem.hasAttribute("data-membership-gift")
			)
				return;

			const memberPriceEl = lineItem.querySelector(".c-item-price__member");
			if (!memberPriceEl) return;

			const regularEl = lineItem.querySelector(".js-price-regular");
			const compareEl = lineItem.querySelector(".js-price-compare");

			if (isUnlocked) {
				// Detect whether an automatic membership discount has already reduced
				// item.price in Liquid (e.g. Script). If so, js-price-regular
				// IS the member price — compare against the variant's list price.
				const variantId = parseInt(lineItem.dataset.itemId);
				let variantsJson = lineItemVariantsCache.get(lineItem);
				if (!variantsJson && lineItem.dataset.variantsJson) {
					variantsJson = validateJson(
						lineItem.dataset.variantsJson.replace(/'/g, '"').trim()
					);
					if (variantsJson) lineItemVariantsCache.set(lineItem, variantsJson);
				}
				const variantObj = variantsJson?.find((v) => v.id == variantId);
				const originalPrice = variantObj?.price;
				const regularText = regularEl?.textContent.trim();
				// compare numbers — formats differ ("$129.99 USD" vs "$129.99")
				const originalValue = global.formatSplitPrice(originalPrice)?.value;
				const regularValue = global.formatSplitPrice(regularText)?.value;
				const isAlreadyDiscounted =
					Number.isFinite(originalValue) &&
					Number.isFinite(regularValue) &&
					originalValue !== regularValue;

				if (compareEl && !compareEl.textContent.trim()) {
					if (isAlreadyDiscounted) {
						// Automatic discount baked in — use variant list price as strikethrough.
						// Match the canonical price-rendering pattern (see js-price-compare
						// branch ~line 228): strip both leading symbol AND trailing currency
						// from the formatted string. siteMoneyFormat already bakes the
						// currency code in for non-USD markets, so re-appending duplicates it.
						const parts = global.formatSplitPrice(originalPrice);
						if (parts) {
							const { value, symbol, currency } = parts;
							const formattedPrice = global.formatShopifyMoney(value);
							const stripped = formattedPrice
								.replace(symbol, "")
								.replace(currency, "");
							compareEl.innerHTML =
								`<span class="currency">${symbol}</span>` + stripped;
						} else {
							compareEl.textContent = originalPrice;
						}
					} else if (regularEl) {
						// No automatic discount — copy regular price as strikethrough
						compareEl.innerHTML = regularEl.innerHTML;
					}
				}

				if (isAlreadyDiscounted) {
					// js-price-member was computed from the already-discounted price,
					// so it double-discounts. Sync it to the regular (= member) price.
					const memberPriceInnerEl =
						memberPriceEl.querySelector(".js-price-member");
					if (memberPriceInnerEl && regularEl) {
						memberPriceInnerEl.innerHTML = regularEl.innerHTML;
					}
				}

				memberPriceEl.classList.add("is-member");
			} else {
				memberPriceEl.classList.remove("is-member");
			}
		});
	},

	// *** free shipping ***
	_shippingRatesCache: {},
	_shippingRatesCacheTtl: 5 * 60 * 1000, // 5 minutes
	_buildRatesCacheKey: function (country, zip, province) {
		const freeshipping = document.querySelector(".js-freeshipping-threshold");
		const totalKey = freeshipping ? freeshipping.dataset.cartTotal : "";
		return `bandit_ship_rates:${country}|${zip || ""}|${province || ""}|${totalKey}`;
	},
	_readRatesCache: function (key) {
		const mem = this._shippingRatesCache[key];
		if (mem && Date.now() - mem.t < this._shippingRatesCacheTtl) {
			return mem.rates;
		}
		try {
			const raw = sessionStorage.getItem(key);
			if (!raw) return undefined;
			const parsed = JSON.parse(raw);
			if (
				parsed &&
				typeof parsed.t === "number" &&
				Date.now() - parsed.t < this._shippingRatesCacheTtl
			) {
				this._shippingRatesCache[key] = parsed;
				return parsed.rates;
			}
			sessionStorage.removeItem(key);
		} catch (e) {
			/* sessionStorage unavailable */
		}
		return undefined;
	},
	_writeRatesCache: function (key, rates) {
		const entry = { rates: rates, t: Date.now() };
		this._shippingRatesCache[key] = entry;
		try {
			sessionStorage.setItem(key, JSON.stringify(entry));
		} catch (e) {
			/* quota / unavailable */
		}
	},
	async fetchShippingRates(country, zip, province) {
		// A country alone can't be rated — US and CA reject it outright with a
		// 422 asking for a ZIP and a state — and this quote only refines the
		// threshold-based bar, so skip the request rather than fire a request
		// that can only fail. Callers keep the threshold render on null.
		if (!country || !zip) return null;

		const cacheKey = this._buildRatesCacheKey(country, zip, province);
		const cached = this._readRatesCache(cacheKey);
		if (cached !== undefined) return cached;

		const params = new URLSearchParams();
		params.set("shipping_address[country]", country);
		params.set("shipping_address[zip]", zip);
		if (province) params.set("shipping_address[province]", province);

		try {
			const response = await fetch(
				`/cart/shipping_rates.json?${params.toString()}`,
				{ headers: { Accept: "application/json" } }
			);
			const data = await response.json();

			// Never cache a failure — the address may be complete on a later
			// call, and a cached null would suppress the quote for the full TTL.
			if (!response.ok) {
				console.error("Shipping rates lookup failed:", data);
				return null;
			}

			const rates = data && data.shipping_rates ? data.shipping_rates : null;
			this._writeRatesCache(cacheKey, rates);
			return rates;
		} catch (error) {
			return null;
		}
	},
	hasFreeShippingRate: function (rates) {
		if (!Array.isArray(rates)) return false;
		return rates.some((r) => {
			const price = parseFloat(r.price);
			if (!isNaN(price) && price === 0) return true;
			const name = (r.name || r.presentment_name || "").toLowerCase();
			return /free/.test(name);
		});
	},
	updateFreeShipping: function (newPrice, freeshipping) {
		// Country comes from the active market, ZIP/province from the customer's
		// saved address, so the two can describe different places. Only pair them
		// when they agree — quoting a US ZIP against a non-US market is rejected.
		const country = freeshipping.dataset.shippingCountry;
		const addressMatchesMarket =
			freeshipping.dataset.shippingAddressCountry &&
			freeshipping.dataset.shippingAddressCountry === country;
		const zip = addressMatchesMarket ? freeshipping.dataset.shippingZip : "";
		const province = addressMatchesMarket
			? freeshipping.dataset.shippingProvince
			: "";
		const progressBar = freeshipping.querySelector(
			".js-freeshipping-progress-bar"
		);
		const diff = freeshipping.querySelector(".js-freeshipping-diff");

		// Unlock free shipping for members or when a (non-gift) membership is in cart.
		// cart-has-membership is already scoped to exclude [data-membership-gift] items.
		// Also unlock when the cart contains only gift items (no regular products).
		const cartLineItems = document.querySelectorAll(".js-line-item");
		const cartHasOnlyGiftItems =
			cartLineItems.length > 0 &&
			[...cartLineItems].every((el) => el.hasAttribute("data-membership-gift"));
		// Nothing ships when every item is pickup-only, so the bar stays empty even
		// for members.
		const cartHasOnlyPickupItems =
			cartLineItems.length > 0 &&
			[...cartLineItems].every((lineItem) =>
				lineItem.hasAttribute("data-pickup-only")
			);
		const memberUnlock =
			!cartHasOnlyPickupItems &&
			(root.classList.contains("is-login-member") ||
				root.classList.contains("cart-has-membership") ||
				cartHasOnlyGiftItems);

		// Threshold (visual hint only) with FX conversion.
		let threshold = parseFloat(freeshipping.dataset.freeshippingThreshold);
		const thresholdCurrency =
			freeshipping.dataset.freeshippingThresholdCurrency;
		const activeCurrency =
			window.cartCurrencyCode ||
			(window.Shopify && Shopify.currency && Shopify.currency.active);
		const fxRate =
			window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
		if (
			thresholdCurrency &&
			activeCurrency &&
			activeCurrency !== thresholdCurrency &&
			fxRate
		) {
			threshold = threshold * fxRate;
		}

		const renderProgress = (isFree) => {
			freeshipping.classList.remove("is-loading");
			freeshipping.classList.remove("is-hidden");
			freeshipping.classList.toggle("is-freeshipping", isFree);
			const diffValue = threshold - newPrice;
			if (diff) {
				const diffValueWithoutCurrency = global
					.formatShopifyMoney(diffValue)
					.replace(".00", "")
					.replace(/[^$\d,\.]/g, "");
				// Only animate when the value actually changes — avoids a flash
				// when the same value is re-rendered (e.g. drawer open re-init).
				if (diff.textContent.trim() !== diffValueWithoutCurrency.trim()) {
					diff.classList.add("js-freeshipping-diff--pending");
					diff.innerHTML = diffValueWithoutCurrency;
					// Two rAFs: paint the opacity:0 state with new text, then
					// transition back to opacity:1 over 0.2s.
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							diff.classList.remove("js-freeshipping-diff--pending");
						});
					});
				}
			}
			progressBar.style.width =
				isFree || newPrice > threshold
					? "100%"
					: `${((newPrice / threshold) * 100).toFixed(0)}%`;
		};

		// Phase 1: synchronous threshold-based render — paint immediately.
		const thresholdSaysFree = memberUnlock || newPrice >= threshold;
		renderProgress(thresholdSaysFree);

		if (memberUnlock) return;
		// Bar already painted from threshold; without a ZIP there's nothing to
		// quote against, so leave it as-is.
		if (!country || !zip) return;
		// Shopify's quote counts pickup-only items toward the threshold, which the
		// bar leaves out, so it would undo the exclusion. Keep the threshold render.
		if (document.querySelector(".js-line-item[data-pickup-only]")) return;

		// Phase 2: silently correct from Shipping Rates API.
		this.fetchShippingRates(country, zip, province).then((rates) => {
			if (rates === null) return; // API failure — keep threshold render.
			const apiSaysFree = this.hasFreeShippingRate(rates);
			if (apiSaysFree !== thresholdSaysFree) {
				renderProgress(apiSaysFree);
			}
		});
	},

	applyOptimisticFreeShipping: function (deltaPrice) {
		const freeshipping = document.querySelector(".js-freeshipping-threshold");
		if (!freeshipping) return;
		const current = parseFloat(freeshipping.dataset.cartTotal) || 0;
		const newTotal = current + deltaPrice;
		if (!Number.isFinite(newTotal)) return;
		freeshipping.dataset.cartTotal = newTotal;
		this.updateFreeShipping(newTotal, freeshipping);
	},

	// *** minicart ***
	getMinicartDom: function () {
		return document.querySelector(".global-minicart");
	},
	minicartClose: function () {
		closeDialog(this.getMinicartDom());
	},
	// Kept as a public method: the membership iframe bridge in layout/theme.liquid
	// calls cCart.minicartOpen() directly.
	minicartOpen: function (trigger = null) {
		const dialog = this.getMinicartDom();
		if (!dialog || dialog.open) return;

		openDialog(dialog, { trigger });
		// A bare fragment resolves against the current URL, so path and query
		// survive; only the hash is added. Keep the entry's state: productSwap
		// only handles popstate for the history entries it marked.
		history.replaceState(history.state, null, "#cart");
	},
	// Cart-scoped accordion (decoupled from initAccordions in js-index.js so
	// cart internals can re-render via innerHTML swaps without losing their
	// click handler).
	initCartAccordion: function () {
		on("body", "click", ".js-cart-accordion-toggle", (e) => {
			const accordion = e.target.closest(".comp-accordion");
			if (!accordion) return;
			const content = accordion.querySelector(".accordion-content");
			if (!content) return;
			accordion.classList.toggle("is-expanded");
			const interior = content.querySelector(".content-interior");
			if (accordion.classList.contains("is-expanded")) {
				accordion.setAttribute("aria-expanded", "true");
				content.setAttribute("aria-hidden", "false");
				content.style.height = `${interior?.clientHeight ?? 0}px`;
			} else {
				accordion.setAttribute("aria-expanded", "false");
				content.setAttribute("aria-hidden", "true");
				content.style.height = "0px";
			}
		});
	},

	initMinicart: function () {
		const dialog = this.getMinicartDom();
		if (!dialog) return;

		// .minicart-close / .minicart-open are kept alongside the js- hooks: the
		// membership iframe bridge falls back to clicking .minicart-open.
		on("body", "click", ".js-minicart-close, .minicart-close", () =>
			this.minicartClose()
		);
		on("body", "click", ".js-minicart-open, .minicart-open", (e) =>
			this.minicartOpen(e.target.closest(".js-minicart-open, .minicart-open"))
		);

		// Escape, the focus trap and the inert background come from showModal().
		// Drop the #cart hash on every close path — button, backdrop or Escape.
		dialog.addEventListener("close", () => {
			history.replaceState(history.state, null, " ");
		});

		// The upsell rack's carousel measures its slides at construction, and a
		// closed dialog is display:none — so it has to (re)build once the drawer
		// is on screen. Same for the empty/filled state, which used to be driven
		// by an aria-hidden observer on the drawer itself.
		dialog.addEventListener("bandit:dialog-open", () => {
			this.updateAriaHiddenInCart();
			this.initOrReInitUpsellEmbla();
		});

		// templates/cart.liquid is a redirect to /#cart, so this is the only way
		// the /cart route works.
		if (location.hash === "#cart") this.minicartOpen();
	},

	updateAriaHiddenInCart: function (isHidden = false) {
		document.querySelectorAll(".c-cart").forEach((cartDom) => {
			const itemCount = parseInt(cartDom.dataset?.itemCount, 10) || 0;
			cartDom
				.querySelector(".js-cart-empty")
				.setAttribute("aria-hidden", isHidden ? "true" : itemCount > 0);
			cartDom
				.querySelector(".js-cart-wrapper")
				.setAttribute("aria-hidden", isHidden ? "true" : itemCount <= 0);
		});
	},

	// *** add-to-cart helpers ***
	getFormProperties: function (form, id) {
		const isMembersOnly = form
			.querySelector('input[name="id"]')
			?.classList.contains("is-members-only");
		const isLimitedPurchase = form.classList.contains("is-limited-purchase");
		const isExcludeMemberDiscount = form.classList.contains(
			"is-exclude-member-discount"
		);
		const giftItemsArr = this.getGiftWithPurchaseItems(form, 1, id);

		const propertiesFromForm = {};
		form.querySelectorAll('[name^="properties"]').forEach((input) => {
			const key = input.name.match(/\[(.*?)\]/)?.[1] || input.name;
			propertiesFromForm[key] = input.value;
		});

		return {
			properties: {
				...(isMembersOnly ? { Exclusive: "Members Only" } : {}),
				...(isLimitedPurchase ? { "Limited Purchase": "1" } : {}),
				...(isExcludeMemberDiscount ? { _excludeMemberDiscount: true } : {}),
				...(form.classList.contains("is-gift-with-purchase") && giftItemsArr
					? { _giftWithPurchaseMain: id }
					: {}),
				...propertiesFromForm,
			},
			giftItemsArr,
		};
	},
	getGiftWithPurchaseItems: function (form, quantity, mainVariantId) {
		return Array.from(
			form?.querySelectorAll('input[name="giftWithPurchase"]') || []
		).map((input) => ({
			id: input.value,
			quantity: quantity || 1,
			properties: {
				_giftWithPurchase: mainVariantId,
				Type: "Free Gift With Purchase",
			},
		}));
	},

	addMembershipToCart: function (form, target, isSubscriptionGift) {
		const getInputValue = (form, name, tag = "input") =>
			form?.querySelector(`${tag}[name="properties[${name}]"]`)?.value || "";
		const subscriptionInput = form.querySelector(
			'input[name="properties[subscription]"]'
		);

		const giftFields = {
			gifterName: getInputValue(form, "_givy_gifter_name"),
			recipientName: getInputValue(form, "_givy_recipient_name"),
			recipientEmail: getInputValue(form, "_givy_recipient_email"),
			message: getInputValue(form, "_givy_message", "textarea"),
			sendDate: getInputValue(form, "_givy_send_date"),
			sellingPlanData: getInputValue(form, "_givy_selling_plan_data"),
			sendMethod: getInputValue(form, "_givy_send_method"),
		};

		let subscriptionProperties = null;
		if (isSubscriptionGift) {
			subscriptionProperties = {
				properties: {
					Type: `Membership Gift to ${giftFields.recipientName}, mailed to ${
						giftFields.recipientEmail
					}${giftFields?.sendDate ? ` on ${giftFields.sendDate}` : ""}`,
					_type: "membershipGift",
					_excludeMemberDiscount: true,
					// Givy requires these exact snake_case property names — do not
					// derive them from the giftFields keys.
					_givy_send_method: giftFields.sendMethod,
					_givy_gifter_name: giftFields.gifterName,
					_givy_recipient_name: giftFields.recipientName,
					_givy_recipient_email: giftFields.recipientEmail,
					_givy_message: giftFields.message,
					_givy_send_date: giftFields.sendDate,
					_givy_selling_plan_data: giftFields.sellingPlanData,
				},
			};
		} else if (subscriptionInput) {
			subscriptionProperties = {
				selling_plan: subscriptionInput.value,
				properties: {
					Subscription: subscriptionInput.dataset.sellingPlanName,
					Type: "Membership",
				},
			};
		}

		const productGroup = Array.from(
			form.querySelectorAll("[data-add-id-membership]")
		).map((item) => {
			const isGiftedMembershipGiftCard =
				item.classList.contains("is-gift-card");
			const props = {
				...(!isSubscriptionGift
					? { Type: "Member Product" }
					: { _type: "membershipGiftAddOnProduct" }),
			};

			if (isGiftedMembershipGiftCard) {
				Object.assign(props, {
					__shopify_send_gift_card_to_recipient: true,
					"Recipient name": giftFields.gifterName,
					"Recipient email": giftFields.recipientEmail,
					Message: giftFields.message,
					"Send on": giftFields.sendDate,
				});
			}

			// Ensure the delivery note is carried over to socks in the cart
			if (
				item.classList.contains("is-main-product") &&
				item.dataset.deliveryNote
			) {
				props["Note"] = item.dataset.deliveryNote;
			}

			return {
				id: item.dataset.addIdMembership,
				quantity: 1,
				properties: props,
			};
		});

		const cartItemsArray = [
			...productGroup,
			{ id: target.dataset.addId, quantity: 1, ...subscriptionProperties },
		];

		if (
			root.classList.contains("is-lockdown") &&
			!root.classList.contains("is-countdown-complete")
		) {
			// FIXED: Reverted back to `%26` joining because Shopify's `/cart/clear`
			// requires the entire cart add string to act as the single value for the `return_to` parameter.
			const cartAddPathParams = [];

			cartItemsArray.forEach((item) => {
				cartAddPathParams.push(`items[][id]=${item.id}`);
				cartAddPathParams.push(`items[][quantity]=${item.quantity}`);
				if (item.selling_plan)
					cartAddPathParams.push(`items[][selling_plan]=${item.selling_plan}`);
				if (item.properties) {
					Object.entries(item.properties).forEach(([key, value]) => {
						cartAddPathParams.push(
							`items[][properties][${encodeURIComponent(
								key
							)}]=${encodeURIComponent(value)}`
						);
					});
				}
			});

			cartAddPathParams.push(`return_to=/checkout`);
			const baseUrl = `${siteUrl}/cart/clear?return_to=/cart/add?`;

			location.href = baseUrl + cartAddPathParams.join("%26");
		} else {
			this.addItems({
				items: cartItemsArray,
				callback: () => {
					loader.complete(root);
					this.minicartOpen();
					// Double rAF: the held state needs one painted frame before the
					// release, or the JOIN NOW → REMOVE swap skips its fade.
					requestAnimationFrame(() =>
						requestAnimationFrame(() =>
							root.classList.remove("cart-membership-pending")
						)
					);
					if (!isSubscriptionGift) {
						// Re-fetch + swap members-only blocks so PDP/PLP unlock without a reload.
						// Must run AFTER addItems completes so the fetched page reflects the new cart.
						updateProductFormsCards();
						// Unlock the quick-add panel (clears its cached section HTML).
						document.dispatchEvent(
							new CustomEvent("bandit:membership-changed")
						);
					}
				},
				// The membership never made it into the cart — release the held
				// state set below so the JOIN NOW button doesn't stay stuck.
				onError: () => {
					if (!isSubscriptionGift) {
						root.classList.remove(
							"cart-has-membership",
							"cart-membership-pending"
						);
					}
				},
			});
		}

		// cart-membership-pending holds the membership JOIN NOW / REMOVE swap (CSS)
		// until the add request settles — cart-has-membership alone flips it while
		// the item is still being added.
		if (!isSubscriptionGift)
			root.classList.add("cart-has-membership", "cart-membership-pending");
	},

	// init
	init: function () {
		this.initBogosCartRefresh();
		on("body", "click", "[data-cart-add-id]", (e) => {
			const target = e.target.closest("[data-cart-add-id]");
			const form = e.target.closest(".card-quick-add");
			loader.updateProgress(root);

			if (form?.classList.contains("is-membership-gift")) {
				this.addMembershipToCart(form, target, true);
			} else if (
				form?.classList.contains("is-membership") &&
				!root.classList.contains("cart-has-membership")
			) {
				this.addMembershipToCart(form, target, false);
			} else {
				const { properties, giftItemsArr } = this.getFormProperties(
					target.closest(".c-item-card") || form || target,
					target.dataset.cartAddId
				);
				this.addItems({
					items: [
						{
							id: target.dataset.cartAddId,
							quantity: target.dataset.cartAddQuantity || 1,
							properties,
						},
						...(giftItemsArr || []),
					],
					callback: () => {
						loader.complete(root);
						this.minicartOpen();
					},
				});
			}
		});

		on("body", "submit", 'form[action="/cart/add"]', (e) => {
			e.preventDefault();
			const form = e.target.closest('form[action="/cart/add"]');
			if (form.dataset.availabilityDisabled === "true") return;
			if (form.classList.contains("js-upsell-item-form")) {
				this.collapseUpsellSlide(form);
			}
			const productHero = form.closest(".product-hero, .product-hero-2026");
			const quantity = form.querySelector('input[name="quantity"]')?.value || 1;
			const id = form.querySelector('input[name="id"]')?.value || "";
			const { properties, giftItemsArr } = this.getFormProperties(form, id);

			const addItemsArr = [
				{ id, quantity, properties },
				...(giftItemsArr || []),
			];
			loader.updateProgress(root);

			if (form.classList.contains("is-membership-gift")) {
				this.addMembershipToCart(
					form,
					form.querySelector("[data-add-id]"),
					true
				);
			} else if (form.classList.contains("is-membership")) {
				this.addMembershipToCart(
					form,
					form.querySelector("[data-add-id]"),
					false
				);
			} else if (form.classList.contains("is-gift-card")) {
				// FIXED: Restored original explicit strict validation logic
				const recipientForm = productHero?.querySelector(
					".js-recipient-form form"
				);

				if (!recipientForm) {
					this.addItems({
						items: addItemsArr,
						callback: () => {
							loader.complete(root);
							this.minicartOpen();
						},
					});
					return false;
				}

				const hasRecipient = productHero.querySelector(
					'input[name="properties[__shopify_send_gift_card_to_recipient]"]'
				);
				const recipientEmail = productHero.querySelector(
					'input[name="properties[Recipient email]"]'
				);
				const recipientName = productHero.querySelector(
					'input[name="properties[Recipient name]"]'
				);
				const recipientMesg = productHero.querySelector(
					'textarea[name="properties[Message]"]'
				);
				const recipientDate = productHero.querySelector(
					'input[name="properties[Send on]"]'
				);

				const recipientProperties = { properties: {} };

				if (hasRecipient && hasRecipient.checked) {
					recipientProperties.properties[
						"__shopify_send_gift_card_to_recipient"
					] = true;

					if (recipientEmail.value.trim() == "") {
						recipientForm.reportValidity();
						return false;
					}

					if (
						recipientDate.value.trim() !== "" &&
						recipientDate.classList.contains("invalid")
					) {
						recipientForm.reportValidity();
						return false;
					}
				} else if (hasRecipient && !hasRecipient.checked) {
					recipientForm.reset();
				}

				if (recipientEmail.value.trim() !== "")
					recipientProperties.properties["Recipient email"] =
						recipientEmail.value.trim();
				if (recipientName.value.trim() !== "")
					recipientProperties.properties["Recipient name"] =
						recipientName.value.trim();
				if (recipientMesg.value.trim() !== "")
					recipientProperties.properties.Message = recipientMesg.value.trim();
				if (recipientDate.value.trim() !== "")
					recipientProperties.properties["Send on"] =
						recipientDate.value.trim();

				this.addItems({
					items: [{ id: id, quantity: quantity, ...recipientProperties }],
					callback: () => {
						loader.complete(root);
						this.minicartOpen();
					},
				});
			} else {
				this.addItems({
					items: addItemsArr,
					callback: () => {
						loader.complete(root);
						this.minicartOpen();
					},
				});
			}

			if (form.classList.contains("is-limited-purchase"))
				updateAllLimitedPurchaseForms(form);
		});

		this.initLineItem();
		this.initMinicart();
		this.initUpsell();

		// Add membership via the hidden .is-membership payload block rendered
		// inside the membership summary (c-cart.liquid).
		const addMembershipFromSummary = (clickTarget) => {
			const membershipRoot = document.querySelector(
				".c-cart__summary__membership"
			);
			const membershipContainer =
				membershipRoot?.querySelector(".is-membership");
			const addButton = membershipRoot?.querySelector("button[data-add-id]");
			if (
				!membershipContainer ||
				!addButton ||
				root.classList.contains("cart-has-membership")
			)
				return;
			loader.updateProgress(root);
			this.addMembershipToCart(membershipContainer, addButton, false);
		};

		const removeMembershipFromSummary = (clickTarget) => {
			if (!root.classList.contains("cart-has-membership")) return;
			clickTarget
				.closest(".c-cart")
				?.querySelector(".c-line-item[data-membership]")
				?.querySelector(".js-item-remove-trigger")
				?.click();
		};

		on("body", "click", ".js-cart-membership-add", (e) => {
			addMembershipFromSummary(e.target);
		});

		on("body", "click", ".js-cart-membership-remove", (e) => {
			removeMembershipFromSummary(e.target);
		});

		this.initCartAccordion();

		// Remove members-only + complimentary items on member logout (they're no
		// longer purchasable once the customer isn't a member).
		on("body", "click", ".js-account-logout", async (e) => {
			const target = e.target.closest(".js-account-logout");
			const redirectUrl = target.dataset.url;
			const redirectTo = (url) => {
				window.location.href = url;
			};

			// Decide from the fresh cart, not root classes — those reflect only the
			// tab where the cart last changed, so a logout in another tab would skip
			// cleanup. membershipCleanupKeys returns [] when there's nothing to remove.
			let variantKeys;
			try {
				variantKeys = await this.membershipCleanupKeys({
					includeMembersOnly: true,
				});
			} catch (error) {
				// Never let a failed cart read block signing out. Without this the
				// throw skips the redirect entirely and clicking Logout does nothing,
				// leaving the shopper unable to tell whether they're signed out.
				console.error("Logout cart cleanup skipped:", error);
				redirectTo(redirectUrl);
				return;
			}
			if (variantKeys.length === 0) {
				redirectTo(redirectUrl);
				return;
			}

			const updates = Object.fromEntries(variantKeys.map((k) => [k, 0]));
			fetch("/cart/update.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({ updates }),
			})
				.then((response) =>
					response.json().then((data) => {
						// Log but never block logout on a failed cleanup.
						if (!response.ok) {
							console.error(
								"Logout cart cleanup failed:",
								data?.description || data?.message || response.status
							);
						}
					})
				)
				.then(() => {
					this.updateCartContent();
					setTimeout(() => redirectTo(redirectUrl), 2000);
				})
				.catch((error) => {
					console.error("Error:", error);
					redirectTo(redirectUrl);
				});
		});

		this.updateCartStats();
		this.clearOrphanedMembersOnlyItems();
	},
};

// ***INFINITE SCROLL***
// The next page loads on its own once the pagination footer comes within one
// viewport height of the fold. That is an IntersectionObserver on the footer
// (rootMargin of 100% of the viewport below it) rather than the plugin's own
// throttled scroll watcher, so it costs nothing while the visitor scrolls and
// needs no resize handling. Each page fetches just this section through the
// Section Rendering API instead of the whole document.
const cInfiniteScroll = {
	// The page the grid is currently showing, taken from the URL rather than the
	// next link: a filter swap rewrites the URL through pushState and then re-runs
	// init(), so this stays correct without reading the swapped-in markup.
	currentPageFromLocation() {
		const pageParameter = new URLSearchParams(window.location.search).get(
			"page"
		);
		const pageNumber = parseInt(pageParameter, 10);
		return Number.isNaN(pageNumber) || pageNumber < 1 ? 1 : pageNumber;
	},

	createNewInfiniteScroll(el) {
		const id = el.dataset.infiniteScrollId;
		const grid = el.querySelector(`.js-infinite-scroll-grid-${id}`);
		if (!grid) return null;

		// destroy infinite scroll instance (and its observer) if one already exists
		const existingInstance = InfiniteScroll.data(grid);
		if (existingInstance) existingInstance.destroy();
		if (grid.infiniteScrollObserver) {
			grid.infiniteScrollObserver.disconnect();
			delete grid.infiniteScrollObserver;
		}

		// Both are rendered by c-pagination-footer, the anchor only while a next
		// page exists — either one missing means there is nothing left to load.
		if (!el.querySelector(`.js-infinite-scroll-next-${id}`)) return null;
		const footer = el.querySelector(".js-pagination");
		if (!footer) return null;

		const section = el.closest(".shopify-section");
		if (!section) return null;
		const sectionId = section.id.replace("shopify-section-", "");

		const startPage = cInfiniteScroll.currentPageFromLocation();

		const instance = new InfiniteScroll(grid, {
			// Returning an absolute path keeps this function as the source of the
			// URL for every page; the plugin otherwise resolves it once at startup.
			// `this` is the InfiniteScroll instance, and loadCount is the number of
			// pages appended so far.
			path() {
				const nextUrl = new URL(window.location.href);
				nextUrl.searchParams.set("page", startPage + this.loadCount + 1);
				nextUrl.searchParams.set("sections", sectionId);
				return nextUrl.pathname + nextUrl.search;
			},
			// The plugin's own scroll watcher stays off; the observer below is the
			// only trigger.
			scrollThreshold: false,
			loadOnScroll: false,
			// The section response is JSON, so the plugin's own appending and
			// last-page detection (both DOM-based) happen in the load handler below.
			responseBody: "json",
			checkLastPage: false,
			history: false,
		});

		// loadNextPage() is a no-op while a request is in flight or once the
		// last page has been reached, so firing it on every intersection is safe.
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					instance.loadNextPage();
				}
			},
			{ rootMargin: "0px 0px 100% 0px" }
		);
		observer.observe(footer);
		grid.infiniteScrollObserver = observer;

		return { instance, id, sectionId, observer, footer };
	},

	init() {
		document.querySelectorAll(".js-infinite-scroll").forEach((el) => {
			const created = cInfiniteScroll.createNewInfiniteScroll(el);
			if (!created) return;
			const { instance, id, sectionId, observer, footer } = created;

			// Mirrors what c-pagination-footer renders once there is no next page:
			// no message, and no footer margin.
			const stopLoading = () => {
				observer.disconnect();
				footer.querySelector(".c-pagination__message")?.remove();
				footer.classList.add("no-next-page");
				loader.complete(root);
			};

			instance.on("request", () => {
				loader.updateProgress(root);
			});

			instance.on("load", (responseBody, path) => {
				const sectionHtml = responseBody && responseBody[sectionId];
				if (!sectionHtml) {
					instance.lastPageReached(responseBody, path);
					return;
				}

				const incomingDocument = parseHtmlString(sectionHtml);
				const items = incomingDocument.querySelectorAll(
					`.js-infinite-scroll-item-${id}`
				);
				if (items.length) instance.appendItems(items);

				// The incoming page carries its own footer, so the absence of a next
				// link there is what marks the end.
				if (!incomingDocument.querySelector(`.js-infinite-scroll-next-${id}`)) {
					instance.lastPageReached(incomingDocument, path);
					return;
				}

				// Re-observing reports the footer's current position, so a footer
				// still within one viewport after the append (short page, tall
				// screen) fetches the next page without waiting for a scroll.
				observer.unobserve(footer);
				observer.observe(footer);

				loader.complete(root);
			});

			instance.on("error", stopLoading);
			instance.on("last", stopLoading);
		});
	},
};

// ***GLOBAL SEARCH***
const gSearch = {
	root: null,
	searchUrl: "/search",
	predictUrl: "/search/suggest",
	input: null,
	body: null,
	suggestionsHeading: null,
	suggestionsList: null,
	productsHeading: null,
	productsBody: null,
	staticSuggestionsHTML: "",
	staticProductsHTML: "",
	hasIdleProducts: false,
	labelPopular: "",
	labelDidYouMean: "",
	labelSuggested: "",
	labelResults: "",
	labelSearching: "",
	labelEmpty: "",
	labelViewMore: "",
	resultsLimit: 24,
	suggestionsTimer: null,
	productsTimer: null,
	suggestionsReqId: 0,
	productsReqId: 0,
	suggestionsAbort: null,
	productsAbort: null,
	lastSuggestionsQuery: null,
	lastProductsQuery: null,

	init: function () {
		this.searchParent = document.querySelector(".global-search");
		if (!this.searchParent) return;

		this.root = this.searchParent.querySelector("[data-search-url]");
		if (!this.root) return;

		this.searchUrl = this.root.dataset.searchUrl || this.searchUrl;
		this.predictUrl = this.root.dataset.predictUrl || this.predictUrl;
		this.labelPopular = this.root.dataset.labelPopular || "Popular searches";
		this.labelDidYouMean = this.root.dataset.labelDidYouMean || "Did you mean";
		this.labelSuggested =
			this.root.dataset.labelSuggested || "Suggested products";
		this.labelResults = this.root.dataset.labelResults || "Product results";
		this.labelSearching = this.root.dataset.labelSearching || "Searching…";
		this.labelEmpty = this.root.dataset.labelEmpty || "No products found";
		this.labelViewMore = this.root.dataset.labelViewMore || "View all results";

		this.input = this.searchParent.querySelector(".js-search-input");
		this.body = this.searchParent.querySelector(".global-search__body");
		this.suggestionsHeading = this.searchParent.querySelector(
			".js-search-suggestions-heading"
		);
		this.suggestionsList = this.searchParent.querySelector(
			".js-search-suggestions-list"
		);
		this.productsHeading = this.searchParent.querySelector(
			".js-search-products-heading"
		);
		this.productsBody = this.searchParent.querySelector(
			".js-search-products-body"
		);

		this.staticSuggestionsHTML = this.suggestionsList
			? this.suggestionsList.innerHTML
			: "";
		this.staticProductsHTML = this.productsBody
			? this.productsBody.innerHTML
			: "";
		const productsRoot = this.searchParent.querySelector(
			".global-search__products"
		);
		this.hasIdleProducts = productsRoot
			? productsRoot.dataset.hasIdle === "true"
			: false;

		this.bindEvents();
	},

	bindEvents: function () {
		const self = this;

		// Opening and closing is c-dialog's; restore the caret once it is up.
		this.dialog = this.searchParent.querySelector("dialog.c-dialog");
		this.dialog?.addEventListener("bandit:dialog-open", () =>
			self.focusInput()
		);

		on("body", "click", ".js-search-clear", () => {
			self.clearInput();
		});

		if (this.input) {
			this.input.addEventListener("input", (e) => {
				const query = e.target.value;
				clearTimeout(self.suggestionsTimer);
				clearTimeout(self.productsTimer);
				self.suggestionsTimer = setTimeout(() => {
					self.searchSuggestions(query);
				}, 100);
				self.productsTimer = setTimeout(() => {
					self.searchProducts(query);
				}, 250);
			});
		}
	},

	// autofocus puts the caret at the start of a prefilled term; re-assigning the
	// value moves it to the end.
	focusInput: function () {
		if (!this.input) return;

		this.input.focus();
		const term = this.input.value;
		this.input.value = "";
		this.input.value = term;
	},

	clearInput: function () {
		clearTimeout(this.suggestionsTimer);
		clearTimeout(this.productsTimer);
		if (this.input) {
			this.input.value = "";
			this.input.focus();
		}
		this.searchSuggestions("");
		this.searchProducts("");
	},

	searchSuggestions: function (query) {
		const q = (query || "").trim();
		if (q === this.lastSuggestionsQuery) return;
		this.lastSuggestionsQuery = q;

		if (this.suggestionsAbort) this.suggestionsAbort.abort();

		if (q === "") {
			this.suggestionsAbort = null;
			this.resetSuggestions();
			return;
		}

		const controller = new AbortController();
		this.suggestionsAbort = controller;
		const reqId = ++this.suggestionsReqId;

		this.fetchPredictiveQueries(q, controller.signal)
			.then((queries) => {
				if (reqId !== this.suggestionsReqId) return;
				if (queries && queries.length > 0) {
					this.renderQueries(queries);
				} else {
					// Predictive returned nothing — fall back to the static popular searches
					this.resetSuggestions();
				}
			})
			.catch((err) => {
				if (err && err.name === "AbortError") return;
				if (reqId !== this.suggestionsReqId) return;
				this.resetSuggestions();
			});
	},

	searchProducts: function (query) {
		const q = (query || "").trim();
		if (q === this.lastProductsQuery) return;
		this.lastProductsQuery = q;

		if (this.productsAbort) this.productsAbort.abort();

		if (q === "") {
			this.productsAbort = null;
			this.resetProducts();
			return;
		}

		const controller = new AbortController();
		this.productsAbort = controller;
		const reqId = ++this.productsReqId;
		this.showLoading();

		this.fetchProductResults(q, controller.signal)
			.then((results) => {
				if (reqId !== this.productsReqId) return;
				if (results && results.total > 0) {
					this.renderProducts(results, q);
				} else {
					this.renderEmpty();
				}
				this.searchParent.classList.remove("is-searching");
			})
			.catch((err) => {
				if (err && err.name === "AbortError") return;
				if (reqId !== this.productsReqId) return;
				this.renderEmpty();
				this.searchParent.classList.remove("is-searching");
			});
	},

	showLoading: function () {
		if (!this.productsBody || !this.productsHeading) return;
		this.searchParent.classList.add("is-searching");
		this.productsHeading.hidden = false;
		this.productsHeading.textContent = this.labelResults;
		this.productsBody.innerHTML = `<div class="global-search__loading t-h-6">${this.labelSearching}</div>`;
	},

	buildUrl: function (base, params) {
		const sep = base.includes("?") ? "&" : "?";
		return base + sep + params;
	},

	fetchPredictiveQueries: function (query, signal) {
		const params =
			"q=" +
			encodeURIComponent(query) +
			"&resources[type]=query&resources[limit]=5&section_id=";
		const url = this.buildUrl(this.predictUrl + ".json", params);

		return fetch(url, { signal })
			.then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
			.then((data) => {
				const queries = data?.resources?.results?.queries || [];
				return queries.map((q) => ({
					text: q.text,
					url: q.url || this.buildSearchHref(q.text),
				}));
			});
	},

	fetchProductResults: function (query, signal) {
		const url = this.buildUrl(
			this.searchUrl,
			"q=" +
				encodeURIComponent(query) +
				"&type=product&section_id=search-content"
		);

		return fetch(url, { signal })
			.then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
			.then((html) => {
				const doc = parseHtmlString(html);
				const grid = doc.querySelector(".js-search-results");
				if (!grid) return { html: "", total: 0 };

				// The section renders one page of results; the panel only shows the
				// first `resultsLimit` cards and links out for the rest.
				const cards = Array.from(grid.children);
				if (!cards.length) return { html: "", total: 0 };
				const visibleCards = cards.slice(0, this.resultsLimit);

				// The section paginates at the same size as `resultsLimit`, so the
				// child count saturates at one page and can never exceed it — read
				// the unpaginated total the grid carries instead, or the "view more"
				// link would never appear.
				const declaredTotal = parseInt(grid.dataset.resultsTotal, 10);

				return {
					html: visibleCards.map((card) => card.outerHTML).join(""),
					total: Number.isNaN(declaredTotal) ? cards.length : declaredTotal,
				};
			});
	},

	buildSearchHref: function (term) {
		return this.buildUrl(
			this.searchUrl,
			"q=" + encodeURIComponent(term) + "&type=product"
		);
	},

	escapeHtml: function (value) {
		return String(value)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;");
	},

	renderQueries: function (queries) {
		if (!this.suggestionsList || !this.suggestionsHeading) return;

		this.suggestionsHeading.textContent = this.labelDidYouMean;

		if (!queries || queries.length === 0) {
			this.suggestionsList.innerHTML = "";
			return;
		}

		this.suggestionsList.innerHTML = queries
			.map((q) => {
				const safeText = this.escapeHtml(q.text);
				return `
					<li class="global-search__suggestions__item t-l-1 js-dialog-close">
						${safeText}
						<a
							href="${q.url}"
							class="p-fill"
							aria-label="Search for ${safeText}"
						></a>
					</li>
				`;
			})
			.join("");
	},

	renderProducts: function (results, query) {
		if (!this.productsBody || !this.productsHeading) return;

		this.productsHeading.hidden = false;
		this.productsHeading.textContent = this.labelResults;

		let markup = `<div class="global-search__grid g g-4">${results.html}</div>`;

		if (results.total > this.resultsLimit) {
			markup += `<div class="global-search__more"><a class="btn-underline is-right t-l-1 js-dialog-close" href="${this.buildSearchHref(
				query
			)}">${this.escapeHtml(this.labelViewMore)}</a></div>`;
		}

		this.productsBody.innerHTML = markup;
	},

	renderEmpty: function () {
		// Right column only — left column is owned by the suggestions channel.
		if (this.productsHeading) this.productsHeading.hidden = true;
		if (this.productsBody)
			this.productsBody.innerHTML = `<div class="global-search__empty t-h-6">${this.labelEmpty}</div>`;
	},

	resetSuggestions: function () {
		if (this.suggestionsHeading)
			this.suggestionsHeading.textContent = this.labelPopular;
		if (this.suggestionsList)
			this.suggestionsList.innerHTML = this.staticSuggestionsHTML;
	},

	resetProducts: function () {
		this.productsReqId++;
		this.searchParent.classList.remove("is-searching");
		if (this.productsHeading) {
			this.productsHeading.textContent = this.labelSuggested;
			this.productsHeading.hidden = !this.hasIdleProducts;
		}
		if (this.productsBody)
			this.productsBody.innerHTML = this.staticProductsHTML;
	},
};

// Filters Bar — the collection/search filter and sort bar.
// Root-scoped so multiple bars (e.g. several search bars) can coexist in the
// DOM; every query is scoped to the bar root passed in, never document-wide.
const cFiltersBar = {
	rootSelector: ".js-filters-bar",
	requestSeq: 0,

	// Every filtered result set is also an in-stock one. The facet is a Search
	// & Discovery filter on the variant metafield custom.online_availability, so
	// Shopify applies it in the index — before pagination — which is what keeps
	// products_count, the size pills' value.count and page boundaries honest.
	// It is never shown in the bar (c-filters-bar.liquid hides it by param_name);
	// withAvailabilityFilter adds it whenever some other filter is active and
	// drops it again when none is, so an unfiltered view still shows sold-out
	// items, exactly as the landing page does.
	availabilityParamKey: "filter.v.m.custom.online_availability",
	availabilityParamValue: "In+Stock",

	// sections/collection-card-count lookups, shared by the size pills and the
	// product count (see refreshCardCounts). The cache is keyed by the request URL
	// minus its page number, so toggling filters back and forth costs no refetch,
	// and it holds the in-flight promise rather than the result — the two
	// consumers then coalesce onto one request whenever their URLs agree, which
	// is every time no size filter is active.
	cardCountSection: "collection-card-count",
	cardCountMaxPages: 8,
	cardCountCache: new Map(),
	cardCountSeq: 0,
	cardCountAbort: null,

	getPanel: function () {
		return document.querySelector("dialog.js-filters-bar-panel");
	},

	// The panel dialog is a sibling of the bar root, so a click inside it has no
	// bar ancestor to climb to — the document-level fallback is what resolves it.
	resolveRoot: function (element) {
		return (
			element?.closest(this.rootSelector) ||
			document.querySelector(this.rootSelector)
		);
	},

	// Query the bar root plus the panel dialog, which is rendered beside the
	// root rather than inside it, so the two never overlap.
	getCombinedElements: function (root, selector) {
		const panel = this.getPanel();
		return [
			...root.querySelectorAll(selector),
			...(panel ? panel.querySelectorAll(selector) : []),
		];
	},

	// Scoped to the bar's own section — avoids reaching into another section's grid.
	resolveResultsTargets: function (root) {
		const section = root.closest(".shopify-section");
		return {
			content: section?.querySelector(".collection-content__content"),
			empty: section?.querySelector(".collection-content__empty"),
		};
	},

	// Current sort as "sort_by=…", or "" for default/manual. Shared by
	// buildParams and the pill handler so both keep sort in the request.
	sortParam: function (root) {
		const sortSelect = root.querySelector(".js-filters-bar-sort");
		if (
			sortSelect?.value &&
			sortSelect.value !== sortSelect.dataset.defaultValue &&
			sortSelect.value !== "manual"
		) {
			return `sort_by=${sortSelect.value}`;
		}
		return "";
	},

	// Normalises the availability facet on a param string: any existing copy
	// is removed first (url_to_remove hands it back url-decoded, "In Stock",
	// so match on the key), then the canonical form is appended if — and only
	// if — another filter.* param is present.
	withAvailabilityFilter: function (paramString) {
		const keyPrefix = `${this.availabilityParamKey}=`;
		const parts = (paramString || "")
			.split("&")
			.filter(Boolean)
			.filter((part) => !part.startsWith(keyPrefix));
		const hasFilter = parts.some((part) => part.startsWith("filter."));
		if (hasFilter) {
			parts.push(`${keyPrefix}${this.availabilityParamValue}`);
		}
		return parts.join("&");
	},

	buildParams: function (root) {
		const parts = [];
		const seen = new Set();

		const add = (name, value) => {
			if (!value) return;
			const entry = `${name}=${value}`;
			if (seen.has(entry)) return;
			seen.add(entry);
			parts.push(entry);
		};

		root
			.querySelectorAll(".js-filters-bar-input:checked")
			.forEach((input) => add(input.name, input.value));

		root
			.querySelectorAll('.js-filters-bar-form input[type="number"]')
			.forEach((input) => add(input.name, input.value));

		const sort = this.sortParam(root);
		if (sort) parts.push(sort);

		return parts.join("&");
	},

	// Recompute every count badge from live checked state (bar + panel).
	updateBadges: function (root) {
		const groupSelector = ".js-filters-bar-dropdown, .js-filters-bar-accordion";

		this.getCombinedElements(root, groupSelector).forEach((group) => {
			let count = group.querySelectorAll(
				".js-filters-bar-input:checked"
			).length;
			group
				.querySelectorAll('.js-filters-bar-form input[type="number"]')
				.forEach((input) => {
					if (input.value) count += 1;
				});

			const badge = group.querySelector(".js-filters-bar-filter-count");
			if (badge) {
				badge.classList.toggle("is-empty", count === 0);
				if (count > 0) badge.textContent = count;
			}
		});

		// Total = unique active values in the bar only, avoids double-counting panel copies.
		const uniqueActive = new Set();
		root
			.querySelectorAll(
				".js-filters-bar-dropdown .js-filters-bar-input:checked"
			)
			.forEach((input) => uniqueActive.add(`${input.name}=${input.value}`));
		root
			.querySelectorAll(
				'.js-filters-bar-dropdown .js-filters-bar-form input[type="number"]'
			)
			.forEach((input) => {
				if (input.value) uniqueActive.add(input.name);
			});

		const total = uniqueActive.size;
		this.getCombinedElements(root, ".js-filters-bar-total").forEach((badge) => {
			badge.classList.toggle("is-empty", total === 0);
			if (total > 0) badge.textContent = total;
		});
	},

	// sort_by and page are dropped so neither changes the cache key. The size
	// facet is dropped too when includeSize is false — that is the size pills'
	// request, and a size should be selectable when it is in stock on anything
	// the OTHER filters allow, or picking one size would grey out every other
	// one. The product count passes includeSize: true, since it has to describe
	// the grid the visitor is actually looking at.
	cardCountUrl: function (page, includeSize) {
		const query = new URLSearchParams(window.location.search);
		const dropped = ["sort_by", "page", "sections"];
		if (!includeSize) dropped.push("filter.v.option.size");
		dropped.forEach((key) => query.delete(key));
		// The pills predict a click, and every click carries the in-stock facet
		// (withAvailabilityFilter), so their lookup carries it too — a size then
		// reads as available only when choosing it will actually show something.
		// The product count describes the grid as rendered instead, so it keeps
		// whatever the page URL has: on an unfiltered landing that grid includes
		// sold-out items, and the count has to say so. (URLSearchParams encodes
		// the space itself, hence the plain-space form here.)
		if (!includeSize) {
			query.set(
				this.availabilityParamKey,
				this.availabilityParamValue.replace("+", " ")
			);
		}
		if (page > 1) query.set("page", page);
		query.set("sections", this.cardCountSection);
		return `${window.location.pathname}?${query.toString()}`;
	},

	// Walks has_next pages (250 products each), summing `count` and unioning
	// `sizes`. Resolves to { count, sizes }; rejects when the lookup fails, and
	// both callers then fail open — the grid gate still keeps sold-out sizes out
	// of the results themselves, so an enabled pill is never a wrong result, and
	// the count keeps the server's estimate.
	fetchCardCount: function (signal, includeSize) {
		const cacheKey = this.cardCountUrl(1, includeSize);
		const cached = this.cardCountCache.get(cacheKey);
		if (cached) return cached;

		const inStockSizes = new Set();
		let cardTotal = 0;
		const fetchPage = (page) =>
			fetch(this.cardCountUrl(page, includeSize), { signal })
				.then((response) => {
					if (!response.ok) throw new Error(response.statusText);
					return response.json();
				})
				.then((payload) => {
					// The Section Rendering API wraps the section in its own <div>;
					// the JSON is that element's text (as subcategory-pills reads it).
					const sectionDocument = parseHtmlString(
						payload[this.cardCountSection]
					);
					const parsed = JSON.parse(sectionDocument.body.textContent.trim());
					// A payload without `sizes` is a section that predates this lookup
					// (a stale render, or JS pushed ahead of the Liquid) — not "nothing
					// in stock". Reject so the pills fail open instead of all greying out.
					if (!Array.isArray(parsed.sizes)) {
						throw new Error("collection-card-count returned no sizes");
					}
					parsed.sizes.forEach((size) => inStockSizes.add(size));
					cardTotal += parsed.count;
					if (parsed.has_next && page < this.cardCountMaxPages) {
						return fetchPage(page + 1);
					}
					return { count: cardTotal, sizes: inStockSizes };
				});

		// The promise is what gets cached, so two consumers asking for the same
		// URL at the same time share one request. A rejection (an abort included)
		// has to drop back out, or it would be replayed for the rest of the visit.
		const request = fetchPage(1).catch((error) => {
			this.cardCountCache.delete(cacheKey);
			throw error;
		});
		this.cardCountCache.set(cacheKey, request);
		return request;
	},

	// Both lookups run off one AbortController and one sequence number: they are
	// always started together, and a newer filter change supersedes both.
	refreshCardCounts: function (root) {
		if (this.cardCountAbort) this.cardCountAbort.abort();
		const controller = new AbortController();
		this.cardCountAbort = controller;
		const requestId = ++this.cardCountSeq;

		this.applySizeAvailability(root, controller.signal, requestId);
		this.applyProductCount(controller.signal, requestId);
	},

	// The bar's product count, and the search header's result count, are both
	// estimates as rendered: collection.products_count / search.results_count
	// know nothing about colour-splitting, hidden products and variants, or the
	// in-stock size gate, and the grid can only count its own page. The real
	// number is what collection-card-count returns for the current filters.
	//
	// Queried from the document rather than the bar root: the search header sits
	// outside it, and the number describes the page rather than one section.
	applyProductCount: function (signal, requestId) {
		const elements = document.querySelectorAll(".js-filters-bar-product-count");
		if (!elements.length) return;

		// Dim only once the lookup is actually slow. A cache hit — every repeat of
		// a filter combination, and every page with no size filter, where this
		// coalesces onto the size pills' request — settles within a frame or two,
		// and greying the count out for that long reads as a glitch rather than
		// as "still working". The server render carries is-pending itself when
		// its own number is an estimate, so nothing is undimmed that shouldn't be.
		const pendingTimer = setTimeout(() => {
			elements.forEach((element) => element.classList.add("is-pending"));
		}, 150);

		// null = lookup failed: keep the server's estimate, just stop dimming it.
		const settle = (count) => {
			elements.forEach((element) => {
				if (count !== null) {
					const noun = element.dataset.countNoun || "Product";
					element.textContent = `${count} ${noun}${count === 1 ? "" : "s"}`;
				}
				element.classList.remove("is-pending");
			});
		};

		// The timer is cleared before the generation guard, not inside settle: a
		// superseded request that returned early would otherwise still fire it,
		// and re-dim a count the newer request had already settled.
		this.fetchCardCount(signal, true)
			.then((result) => {
				clearTimeout(pendingTimer);
				if (requestId !== this.cardCountSeq) return;
				settle(result.count);
			})
			.catch((error) => {
				clearTimeout(pendingTimer);
				if (error.name === "AbortError" || requestId !== this.cardCountSeq)
					return;
				console.error("cFiltersBar product count:", error);
				settle(null);
			});
	},

	// Settles the size pills: a pill is enabled when some in-stock variant
	// carries one of its option values (data-size-values, written by
	// filters-size-option-values) and disabled otherwise. Runs on load and after
	// every bar re-render, since the pill lists are .js-filters-bar-update
	// regions and come back from the server is-pending.
	//
	// Two states are left alone: Shopify's own count==0 decision (a
	// server-rendered is-disabled with no data-size-out-of-stock marker) and a
	// checked pill, which must stay enabled so the selection can be undone.
	applySizeAvailability: function (root, signal, requestId) {
		const inputs = this.getCombinedElements(
			root,
			'.js-filters-bar-input[name="filter.v.option.size"]'
		);
		if (!inputs.length) return;

		// null = lookup failed: clear pending and leave every pill enabled.
		const settle = (inStockSizes) => {
			inputs.forEach((input) => {
				const item = input.closest(".c-filters-bar__pill-item");
				if (!item) return;

				const isServerDisabled =
					item.classList.contains("is-disabled") &&
					!item.hasAttribute("data-size-out-of-stock");
				if (isServerDisabled) return;

				let inStock = true;
				if (inStockSizes && !input.checked) {
					const optionValues = (item.dataset.sizeValues || "").split("###");
					inStock = optionValues.some((value) => inStockSizes.has(value));
				}

				item.classList.remove("is-pending");
				item.classList.toggle("is-disabled", !inStock);
				item.toggleAttribute("data-size-out-of-stock", !inStock);
				input.disabled = !inStock;
			});
		};

		this.fetchCardCount(signal, false)
			.then((result) => {
				if (requestId !== this.cardCountSeq) return;
				settle(result.sizes);
			})
			.catch((error) => {
				if (error.name === "AbortError" || requestId !== this.cardCountSeq)
					return;
				console.error("cFiltersBar size availability:", error);
				settle(null);
			});
	},

	// Toggles pill is-active from a filter param string (ignores sort_by).
	updateSubcategoryPills: function (root, paramString) {
		const pillsSection = document.querySelector(".subcategory-pills");
		if (!pillsSection) return;

		const activeParams = new Set(
			(paramString || "")
				.split("&")
				.filter((part) => part.startsWith("filter."))
		);

		pillsSection.querySelectorAll("[data-pill-filter]").forEach((pill) => {
			const filterParam = pill.dataset.pillFilter;
			const isActive = filterParam
				? activeParams.has(filterParam)
				: activeParams.size === 0;
			pill.classList.toggle("is-active", isActive);
		});
	},

	// Filter values render twice (bar + panel), sharing name+value but not id.
	// Mirror the toggled input's checked state onto its counterpart(s).
	syncMirrorInputs: function (root, input) {
		const selector = `.js-filters-bar-input[name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"]`;
		this.getCombinedElements(root, selector).forEach((mirror) => {
			if (mirror !== input) mirror.checked = input.checked;
		});
	},

	// Optimistically add/remove a chip for a toggled input, ahead of the fetch.
	// Must run before applyFilters' pushState, while location is still the
	// pre-toggle URL — that's the chip's "remove" target.
	toggleActiveChip: function (root, input) {
		const active = root.querySelector(".js-filters-bar-active");
		if (!active) return;

		const match = active.querySelector(
			`.js-filters-bar-remove[data-filter-name="${CSS.escape(input.name)}"][data-filter-value="${CSS.escape(input.value)}"]`
		);

		if (!input.checked) {
			if (match) match.remove();
			return;
		}
		if (match) return;

		const labelEl = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
		const text = labelEl ? labelEl.textContent.trim() : input.value;

		const pill = document.createElement("button");
		pill.type = "button";
		pill.className =
			"c-filters-bar__pill f-h f-a-c t-l-1 js-filters-bar-remove";
		pill.dataset.url = window.location.pathname + window.location.search;
		pill.dataset.filterName = input.name;
		pill.dataset.filterValue = input.value;
		pill.innerHTML = `${text}<span class="icon-close"></span>`;

		const clearAll = active.querySelector(".js-filters-bar-remove-all");
		active.insertBefore(pill, clearAll || null);
	},

	// Swap `height: auto` for a pixel height so the first collapse can animate.
	primeOpenAccordions: function () {
		this.getPanel()
			?.querySelectorAll(".comp-accordion.is-expanded > .accordion-content")
			.forEach((content) => {
				const interior = content.querySelector(".content-interior");
				if (interior) content.style.height = `${interior.clientHeight}px`;
			});
	},

	closeDropdowns: function (root, except) {
		root
			.querySelectorAll(".js-filters-bar-dropdown.is-open")
			.forEach((dropdown) => {
				if (dropdown === except) return;
				dropdown.classList.remove("is-open");
				dropdown
					.querySelector(".js-filters-bar-dropdown-content")
					?.setAttribute("aria-hidden", "true");
				dropdown
					.querySelector(".js-filters-bar-dropdown-toggle")
					?.setAttribute("aria-expanded", "false");
			});
	},

	// Swap the grid + empty containers, scoped to the matching section so separate
	// bars don't overwrite each other. Used by applyDOMUpdate + popstate.
	swapResultsTargets: function (incomingDoc, root) {
		const section = root.closest(".shopify-section");
		const incomingSection = section?.id
			? incomingDoc.getElementById(section.id)
			: incomingDoc;
		const targets = this.resolveResultsTargets(root);
		["content", "empty"].forEach((key) => {
			if (targets[key]) {
				const incomingEl = (incomingSection || incomingDoc).querySelector(
					`.collection-content__${key}`
				);
				if (incomingEl) targets[key].innerHTML = incomingEl.innerHTML;
			}
		});
	},

	// Swaps `.js-filters-bar-update` targets + grid/empty, then recomputes badges.
	// Partial update only — popstate needs a full re-render instead (see below).
	applyDOMUpdate: function (incomingDoc, root, skipElement) {
		const skipSwapTarget = skipElement?.closest(".js-filters-bar-update");

		// The bar and the panel are separate subtrees now (the panel is a dialog
		// rendered as a sibling of the bar root), so they pair with their own
		// counterpart in the incoming document. Sharing one index sequence would
		// silently misalign and stop refreshing the panel's inputs.
		const swapRegion = (liveContainer, incomingContainer) => {
			if (!liveContainer || !incomingContainer) return;

			const incomingTargets = [
				...incomingContainer.querySelectorAll(".js-filters-bar-update"),
			];
			const liveTargets = [
				...liveContainer.querySelectorAll(".js-filters-bar-update"),
			];

			liveTargets.forEach((element, index) => {
				if (element !== skipSwapTarget && incomingTargets[index]) {
					element.innerHTML = incomingTargets[index].innerHTML;
				}
			});
		};

		swapRegion(root, incomingDoc.querySelector(this.rootSelector));

		const panel = this.getPanel();
		swapRegion(panel, incomingDoc.querySelector(".js-filters-bar-panel"));
		// Cached accordion heights are stale against the new value lists.
		if (panel?.open) this.primeOpenAccordions();

		this.swapResultsTargets(incomingDoc, root);
		this.updateBadges(root);

		this.refreshCardCounts(root);

		const html = document.documentElement;
		html.classList.remove("is-filters-bar-updating");
		loader.complete(html);
		if (typeof cInfiniteScroll !== "undefined") cInfiniteScroll.init();
	},

	applyFilters: function ({ root, paramString, skipElement }) {
		// Cancel any in-flight request.
		if (this.fetchAbort) this.fetchAbort.abort();
		const controller = new AbortController();
		this.fetchAbort = controller;

		// Generation guard: only the latest of several overlapping requests applies.
		const requestId = ++this.requestSeq;
		const html = document.documentElement;

		html.classList.add("is-filters-bar-updating");
		loader.updateProgress(html);

		// Preserve non-filter / non-sort query params (e.g. ?q= on search).
		const query = new URLSearchParams(window.location.search);
		const kept = [];
		for (const [key, value] of query.entries()) {
			if (!key.includes("filter") && !key.includes("sort_by")) {
				kept.push(`${key}=${value}`);
			}
		}

		const combined = this.withAvailabilityFilter(
			[kept.join("&"), paramString].filter(Boolean).join("&")
		);
		const encoded = encodeURI(combined);

		fetch(`?${encoded}`, { signal: controller.signal })
			.then((response) => response.text())
			.then((data) => {
				// A newer toggle superseded this request — drop the stale response.
				if (requestId !== this.requestSeq) return;
				this.applyDOMUpdate(parseHtmlString(data), root, skipElement);
			})
			.catch((error) => {
				if (error.name === "AbortError" || requestId !== this.requestSeq)
					return;
				console.error("cFiltersBar:", error);
				html.classList.remove("is-filters-bar-updating");
				loader.complete(html);
			});

		window.history.pushState({}, "", `?${encoded}`);
	},

	// The panel is a c-dialog rendered beside the bar root, so it no longer has
	// to be cloned to <body> to survive the popstate re-render or to escape the
	// bar's stacking context.
	initPanel: function () {
		// Accordion heights are measured in px, and a closed dialog is
		// display:none — measuring then would pin every group to 0. Prime once
		// the panel is on screen instead.
		//
		// Delegated from document rather than bound to the dialog element:
		// bandit:dialog-open bubbles, and a theme-editor section reload replaces
		// the dialog node outright, which would silently drop an element-bound
		// listener and leave the accordions unprimed.
		document.addEventListener("bandit:dialog-open", (event) => {
			if (event.target.matches?.(".js-filters-bar-panel")) {
				this.primeOpenAccordions();
			}
		});
	},

	init: function () {
		const html = document.documentElement;

		const runInit = () => {
			this.initPanel();
			const root = document.querySelector(this.rootSelector);
			if (root) this.refreshCardCounts(root);
		};

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", runInit);
		} else {
			runInit();
		}

		// Dropdown toggle
		on("body", "click", ".js-filters-bar-dropdown-toggle", (event) => {
			event.preventDefault();
			const root = this.resolveRoot(event.target);
			if (!root) return;
			const dropdown = event.target.closest(".js-filters-bar-dropdown");
			const wasOpen = dropdown.classList.contains("is-open");

			this.closeDropdowns(root);

			if (!wasOpen) {
				dropdown.classList.add("is-open");
				dropdown
					.querySelector(".js-filters-bar-dropdown-content")
					?.setAttribute("aria-hidden", "false");
				dropdown
					.querySelector(".js-filters-bar-dropdown-toggle")
					?.setAttribute("aria-expanded", "true");
			}
		});

		// Close open dropdowns on outside click
		document.addEventListener("click", (event) => {
			if (event.target.closest(".js-filters-bar-dropdown")) return;
			document
				.querySelectorAll(this.rootSelector)
				.forEach((root) => this.closeDropdowns(root));
		});

		// Sort option (custom dropdown)
		on("body", "click", ".js-filters-bar-sort-option", (event) => {
			const option = event.target.closest(".js-filters-bar-sort-option");
			const root = this.resolveRoot(option);
			if (!root) return;

			const dropdown = option.closest(".js-filters-bar-dropdown");
			const select = dropdown.querySelector(".js-filters-bar-sort");

			dropdown
				.querySelectorAll(".js-filters-bar-list-item")
				.forEach((item) => item.classList.remove("is-active"));
			option.closest(".js-filters-bar-list-item").classList.add("is-active");

			if (select) select.value = option.dataset.sortValue;

			this.applyFilters({
				root,
				paramString: this.buildParams(root),
				skipElement: null,
			});
		});

		// Remove single chip
		on("body", "click", ".js-filters-bar-remove", (event) => {
			event.preventDefault();
			const chip = event.target.closest(".js-filters-bar-remove");
			const root = this.resolveRoot(chip);
			if (!root) return;

			const url = chip.dataset.url || "";
			const paramString = url
				.replace(window.location.pathname, "")
				.replace("?", "");
			chip.remove();

			this.updateSubcategoryPills(root, paramString);
			this.applyFilters({ root, paramString, skipElement: chip });
		});

		// Clear all
		on("body", "click", ".js-filters-bar-remove-all", (event) => {
			event.preventDefault();
			const root = this.resolveRoot(event.target);
			if (root) {
				// Clear filters but keep the shopper's current sort.
				const paramString = this.sortParam(root);
				this.updateSubcategoryPills(root, paramString);
				this.applyFilters({ root, paramString, skipElement: null });
			}
		});

		// Subcategory pill click — same AJAX flow as the bar, replace-all semantics.
		// Falls back to data-pill-url navigation only if no filter bar is present.
		on("body", "click", ".subcategory-pills [data-pill-filter]", (event) => {
			const pill = event.target.closest("[data-pill-filter]");
			if (!pill) return;
			const root = document.querySelector(this.rootSelector);
			if (!root) {
				if (pill.dataset.pillUrl) window.location.href = pill.dataset.pillUrl;
				return;
			}
			// Keep the current sort so the grid stays sorted post-swap.
			const paramString = [pill.dataset.pillFilter, this.sortParam(root)]
				.filter(Boolean)
				.join("&");
			this.updateSubcategoryPills(root, paramString);
			this.applyFilters({ root, paramString, skipElement: null });
		});

		// Checkbox / pill change
		on("body", "change", ".js-filters-bar-input", (event) => {
			const input = event.target.closest(".js-filters-bar-input");
			const root = this.resolveRoot(input);
			if (root) {
				this.syncMirrorInputs(root, input);
				this.toggleActiveChip(root, input);
				this.updateBadges(root);
				const paramString = this.buildParams(root);
				this.updateSubcategoryPills(root, paramString);
				this.applyFilters({
					root,
					paramString,
					skipElement: input,
				});
			}
		});

		// Price range submit
		on("body", "submit", ".js-filters-bar-form", (event) => {
			event.preventDefault();
			const form = event.target.closest(".js-filters-bar-form");
			const root = this.resolveRoot(form);
			if (root)
				this.applyFilters({
					root,
					paramString: this.buildParams(root),
					skipElement: form,
				});
		});

		// Esc closes the bar dropdowns. The panel is a dialog and gets Escape
		// natively, through cDialog's `cancel` handler.
		document.addEventListener("keydown", (event) => {
			if (event.key !== "Escape") return;
			document
				.querySelectorAll(this.rootSelector)
				.forEach((root) => this.closeDropdowns(root));
		});

		// Back/forward — full re-render of the bar root; a partial update would
		// leave checkboxes/badges/sort out of sync with the URL.
		window.addEventListener("popstate", () => {
			const root = document.querySelector(this.rootSelector);
			if (!root) return;

			closeDialog(this.getPanel(), { immediate: true });
			html.classList.add("is-filters-bar-updating");
			loader.updateProgress(html);

			fetch(window.location.pathname + window.location.search)
				.then((response) => response.text())
				.then((data) => {
					const incomingDoc = parseHtmlString(data);
					const incomingRoot = incomingDoc.querySelector(this.rootSelector);
					if (incomingRoot) root.innerHTML = incomingRoot.innerHTML;

					// The panel sits outside the bar root, so the re-render above did
					// not touch it. Swap its contents — never the <dialog> itself,
					// which would drop the element's identity and its [open] state.
					const panel = this.getPanel();
					const incomingPanel = incomingDoc.querySelector(
						".js-filters-bar-panel"
					);
					if (panel && incomingPanel) {
						panel.innerHTML = incomingPanel.innerHTML;
					}

					this.swapResultsTargets(incomingDoc, root);
					this.updateBadges(root);
					this.updateSubcategoryPills(
						root,
						window.location.search.replace(/^\?/, "")
					);
					this.refreshCardCounts(root);
					html.classList.remove("is-filters-bar-updating");
					loader.complete(html);
					if (typeof cInfiniteScroll !== "undefined") cInfiniteScroll.init();
				});
		});
	},
};

// *** DIALOG ***
// Global open / close plumbing for snippets/c-dialog.liquid. The helpers
// (openDialog / closeDialog / closeAllDialogs) live in assets/js-initialize.js,
// which the layout loads synchronously ahead of this file.
const cDialog = {
	init: function () {
		this.bindTriggers();
		this.bindLightDismiss();
		this.bindNativeEvents();
	},

	// A trigger names its dialog with data-dialog. Components that must fill the
	// dialog in before it appears (the back-in-stock popup, the quick-add sheet)
	// call openDialog() themselves instead of using this.
	bindTriggers: function () {
		on("body", "click", ".js-dialog-open", (event) => {
			const trigger = event.target.closest(".js-dialog-open");
			const key = trigger?.dataset.dialog;
			if (!key) return;

			const dialog = document.querySelector(
				`dialog.c-dialog[data-dialog="${key}"]`
			);
			if (dialog) openDialog(dialog, { trigger });
		});

		on("body", "click", ".js-dialog-close", (event) => {
			const dialog = event.target.closest("dialog.c-dialog");
			if (dialog) closeDialog(dialog);
		});
	},

	// Backdrop click. A ::backdrop press targets the <dialog> element itself,
	// anything in the panel targets a descendant. Requiring the pointerdown to
	// have landed on the backdrop too stops a text-selection drag that ends
	// outside the panel from dismissing it.
	bindLightDismiss: function () {
		let pressedBackdrop = null;

		document.addEventListener("pointerdown", (event) => {
			pressedBackdrop = event.target.matches?.("dialog.c-dialog[open]:modal")
				? event.target
				: null;
		});

		document.addEventListener("click", (event) => {
			const isBackdrop = event.target.matches?.("dialog.c-dialog[open]:modal");
			if (isBackdrop && event.target === pressedBackdrop) {
				closeDialog(event.target);
			}
			pressedBackdrop = null;
		});
	},

	bindNativeEvents: function () {
		// Escape. `cancel` doesn't bubble, so listen in the capture phase; the
		// close-watcher stack means only the topmost dialog gets it. Rerouting it
		// through closeDialog() is what makes Escape animate.
		document.addEventListener(
			"cancel",
			(event) => {
				if (!event.target.matches?.("dialog.c-dialog")) return;

				event.preventDefault();
				closeDialog(event.target);
			},
			true
		);

		// `cancel` only fires for a modal dialog. A non-modal one needs Escape
		// wired up by hand, and only when no modal dialog is open above it to
		// take the press first.
		document.addEventListener("keydown", (event) => {
			if (event.key !== "Escape") return;
			if (document.querySelector("dialog.c-dialog[open]:modal")) return;

			const openDialogs = getOpenDialogs();
			const topmost = openDialogs[openDialogs.length - 1];
			if (topmost) closeDialog(topmost);
		});

		// Runs after the exit animation, and also after any raw .close() that
		// bypassed closeDialog() (a forced close by the browser, or app code).
		document.addEventListener(
			"close",
			(event) => {
				const dialog = event.target;
				if (!dialog.matches?.("dialog.c-dialog")) return;

				if (!dialogAnnouncedClose.has(dialog)) {
					dialog.dispatchEvent(
						new CustomEvent("bandit:dialog-close", { bubbles: true })
					);
				}
				dialogAnnouncedClose.delete(dialog);

				cancelPendingDialogClose(dialog);
				dialog.classList.remove("is-nested");

				// Closing the dialog underneath first would leave the survivor with
				// no scrim — give it one back.
				const remaining = getOpenDialogs();
				if (remaining.length === 1 && !root.matches(".overlay-is-active")) {
					remaining[0].classList.remove("is-nested");
				}

				// The browser restores focus on its own. This only covers the case
				// where the element it would have returned to is gone (a re-rendered
				// card, a trigger inside a dialog that has since closed).
				const trigger = dialogTriggers.get(dialog);
				const activeElement = document.activeElement;
				if (
					trigger?.isConnected &&
					(!activeElement || activeElement === document.body)
				) {
					trigger.focus({ preventScroll: true });
				}
				dialogTriggers.delete(dialog);
			},
			true
		);
	},
};

// *** DIALOG SCROLL LOCK ***
// Single owner of the page scroll lock: any open c-dialog locks, none unlocks.
// Watching the `open` attribute means every path — openDialog, closeDialog, a
// raw .close(), or a dialog being added or removed from the DOM — is covered
// without each panel having to remember.
const dialogScrollLockManager = {
	observer: null,

	init: function () {
		if (this.observer) return;

		this.observer = new MutationObserver(() => this.update());
		this.observer.observe(document.body, {
			attributes: true,
			attributeFilter: ["open"],
			childList: true,
			subtree: true,
		});
		this.update();
	},

	update: function () {
		if (!scrollHandler) return;

		if (document.querySelector("dialog.c-dialog[open]")) {
			scrollHandler.scrollDisable();
			return;
		}

		scrollHandler.scrollEnable();
	},
};

// ***EXECUTE FUNCTIONS***
cWysiwygShopify.init();
cItemVariants.init();
cItemSellingPlan.init();
cItemQuantity.init();
cProductForm.init();
productSwap.init();
cCart.init();
cFiltersBar.init();
gSearch.init();
cDialog.init();
dialogScrollLockManager.init();
document.addEventListener("DOMContentLoaded", () => {
	cInfiniteScroll.init();
});
